import { IReactionDisposer, action, computed, observable, reaction, runInAction, toJS } from 'mobx'
import * as _ from 'lodash'
import uuid from 'uuid'
import { StoreExt } from '@utils/reactExt'
import { message } from 'antd'
import { isMobile } from 'react-device-detect'
import { Schema$UserItem } from '@protocol/user'
import {
  IBet,
  IDiagnoseFolds,
  IBinBet,
  IFavoriteMarket,
  IFavoriteMarkets,
  IFavoriteMatch,
  IFavoriteMatchList,
  IMatchupClub,
  IMatchupDetailMarkets,
  IMatchupDetailPackage,
  IMatchupItems,
  IMatchupTracks,
  Schema$BetCall,
  Schema$BetTicket,
  Schema$BinBetCall,
  Schema$FavoriteMarkets,
  Schema$MajorTournamentFilter,
  Schema$MarketBlock,
  Schema$MarketTrack,
  Schema$MatchTrack,
  Schema$MatchupDetailFilter,
  Schema$MatchupMarket,
  Schema$Outcome,
  Schema$PlayingPeriodInfo,
  Schema$TournamentTrack,
} from '@protocol/game'
import { getErrorText, getErrorTextByBetMoneyType, getMixMaxBetError } from '@game/errtext'
import { ERR } from 'adv-protocol/src/ErrorCodes'
import { authStore, clubStore, componentStore, globalStore, messageStore, userStore } from '@store/index'
import {
  canSportCombinations,
  CombinationRuleExt,
  CombitionSource,
  getClubMinMaxBet,
  getSportCombinations,
  Mining,
  replaceMarketName,
} from '@game/util'
import {
  DETAIL_TAB,
  PAGE_TYPE,
  Schema$ClubInfo,
  Schema$ClubOption,
  SPORTS_TYPE,
  SportsFeedMarketProvider,
} from '@interface/common'
import {
  GAME_TYPE,
  GAME_TYPE_REGULAR_FILTER,
  LS_OUTCOMES_HANDICAP,
  LS_OUTCOMES_UNDEROVER,
  LS_OUTCOMES_WAY,
  LS_REGULAR_ODDS_HANDICAP,
  LS_REGULAR_ODDS_UNDEROVER,
  LS_REGULAR_ODDS_WAY,
  UNIFIED_OUTCOMES_HANDICAP,
  UNIFIED_OUTCOMES_UNDEROVER,
  UNIFIED_OUTCOMES_WAY,
  UNIFIED_REGULAR_ODDS_HANDICAP,
  UNIFIED_REGULAR_ODDS_UNDEROVER,
  UNIFIED_REGULAR_ODDS_WAY,
} from '@game-type/game-market-types'
import {
  BET_CALL_TYPE,
  BET_TYPE_ON,
  CLUB_STATE,
  MATCH_GAME_STATUS,
  MATCHUP_CATEGORY,
  PROPERTY_ID,
} from 'adv-protocol/src/GameCommon'
import {
  formatNumber,
  getAllHashParameters,
  getPropertyIdByBetSlipIndexKey,
  getSingleBetPenaltyRate,
  isExtraOddsItemSupportBetMoneyType,
  isLsportsEnv,
  isMajorSportsType,
  isViewPage,
  loadOrReload,
  PlayingPeriodSpecifierKey,
  Profiler,
  showCasinoAdvertisementPopup,
  showToast,
  sleep,
  TOAST_TYPE,
} from '@utils/utils'
import { Schema$ClubBinInfo, Schema$ClubBinInfos, Schema$ClubRules, Schema$CombinationRule } from '@interface/rules'
import {
  BET_SLIP_TAB_INDEX_KEY,
  COOKIE_KEYS,
  DUPLICATE_REQUEST_EXCEPTION,
  MATCHUP_DETAIL_CONTENT_TAB_KEY,
  MOBILE_APP_RECORD_EVENT,
  RATIO_TICKET,
  SUCCESS_LIVE_BET_TEXT,
  SUCCESS_PRE_BET_TEXT,
} from '@constants/index'
import {
  Schema$MatchupFilter,
  Schema$MatchupMetaCategory,
  Schema$MatchupMetaMarket,
  Schema$MatchupMetaMatchStatus,
  Schema$MatchupMetaOutcome,
  Schema$MatchupMetaSport,
  Schema$MatchupMetaTeam,
  Schema$MatchupMetaTournament,
  Schema$SimpleMatchTrack,
} from '@interface/matchup'

import { INotifyUnifiedFeed, INotifyUnifiedStatus } from '@v2/protocol/live'

import { ProducerType } from '@game-type/betradar-type'
import { ClubInfoItem } from '@store/clubStore'
import { PushBetResultPacket } from '@v2/protocol/socket'
import {
  CROSS_TYPES,
  EXCEPTIONAL_SPORT_ID_GROUP,
  EXCEPTIONAL_UNIQUE_ID,
  FEED_SUPPLIER,
  GlobalStoreKey,
  LS_CROSS_TYPES,
  LS_WDL_MARKET_TYPES,
  MARKET_PROVIDER,
  WDL_MARKET_TYPES,
} from '@v2/constants/common'
import { BubbleTextType, BubbleType } from '@store/globalStore'
import { loadanal_dsp, loadGoogleAdsJS_gtagReportConversion } from '@utils/index'
import { validateBetLimitScore } from '@v2/utils/match-utils'
import StorageUtils from '@utils/storage-utils'
import { SimpleMatchTimelineGroup } from '@interface/chat'
import { SettlementSupport } from '@store/authStore'

export type UserItem = Schema$UserItem
export type UserItems = UserItem[]

export type ClubInfo = Schema$ClubInfo
export type ClubOption = Schema$ClubOption
export type ClubRules = Schema$ClubRules
export type ClubBinInfo = Schema$ClubBinInfo
export type ClubBinInfos = Schema$ClubBinInfos
export type CombinationRule = Schema$CombinationRule
export type MetaSport = Schema$MatchupMetaSport
export type MetaCategory = Schema$MatchupMetaCategory
export type MetaTournament = Schema$MatchupMetaTournament
export type MetaTeam = Schema$MatchupMetaTeam
export type MetaMarket = Schema$MatchupMetaMarket
export type MatchupItem = Schema$MatchupMarket
export type MetaMatchStatus = Schema$MatchupMetaMatchStatus
export type MatchupDetailFilter = Schema$MatchupDetailFilter
export type MarketBlock = Schema$MarketBlock
export type OutcomeTrack = Schema$Outcome
export type PlayingPeriodInfo = Schema$PlayingPeriodInfo
export type MarketTrack = Schema$MarketTrack
export type MatchTrack = Schema$MatchTrack
export type TournamentTrack = Schema$TournamentTrack
export type MetaOutcome = Schema$MatchupMetaOutcome
export type SimpleMatchTrack = Schema$SimpleMatchTrack

type TabsUpdater<T> = (prev: T[]) => T[]


export interface DetailMatchTrack {
  gameKey: GAME_TYPE

  sportId: number
  categoryId: number
  tournamentId: number

  sportName: string
  categoryName: string
  tournamentName: string

  sportEmblem: string
  categoryEmblem: string
  tournamentEmblem: string

  track: MatchTrack
}

export interface CartItem {
  cartId: string

  sportId?: number
  categoryId?: number
  tournamentId?: number

  match?: MatchTrack
  specifiers?: { [id: string]: string }
  selection?: string
  outcomeMetaId: string
  rate?: number

  marketId?: string
  marketType?: string
  marketName?: string
  matchId?: number
  value?: string
  checked?: boolean

  changeRate?: ChangeRateData

  isSpecial?: boolean
  selectedOutcome?: OutcomeTrack
  gameKey: GAME_TYPE
  producerId: ProducerType

  isLocked?: boolean
}

export interface ChangeRateData {
  homeTeamName: string
  awayTeamName: string
  marketType: string
  specifier?: { [id: string]: string }
  from: Schema$Outcome
  to: Schema$Outcome
}

export interface MatchupFilterInfo {
  total: number
  major: Schema$MatchupFilter
  minor: Schema$MatchupFilter
  majorList: Schema$MatchupFilter[]
  minorList: Schema$MatchupFilter[]
}

export interface MatchupTrackData {
  tracks: TournamentTrack[]
  isLoading: boolean
  hasMore: boolean
}

export interface ViewController {
  updateField: () => void
  clearField: () => void
  setEnabled: (enabled: boolean) => void
  setEnabledHome?: (enabled: boolean) => void
  setEnabledDraw?: (enabled: boolean) => void
  setEnabledAway?: (enabled: boolean) => void
  isTwoWay: boolean
  field?: string
  oddsBlockType?: string
  restoreOddsButtonGroupStateForCallFromParent: (
    oddsBlockTypeParam: string,
    value: string,
    marketList: Schema$MarketBlock[],
    marketType: string,
    sportId: number,
  ) => void,
  setEnabledHomeFromViewController?: (enabled: boolean) => void,
  setEnabledAwayFromViewController?: (enabled: boolean) => void,
}

export interface TournamentTrackPage {
  page: number
  tracks: TournamentTrack[]
}

export interface FetchItemsParams {
  gameKey: GAME_TYPE
  subKey: string
  uniqueId: number // major unique tournament id
  limit: number
  reset: boolean
}

export interface SimpleFetchItemsParams {
  limit: number
  reset: boolean
  pageType?: PAGE_TYPE
  /** SCORE 리그필터에서 진행중/종료 탭 변경으로 인한 재조회 시 true. 카운트 갱신·리그필터 자동종료 조건에 사용 */
  isDetailTabChange?: boolean
}

export interface OldOutCome {
  type: string
  oldRate: number
  metaId: string
}

// NOTE : 실시간으로 오즈정보를 갱신할때 이전의 oldrate값을 관리하기위한 객체
export interface ChangeOldMarket {
  type: number
  specifiers: { [id: string]: string }
  oldOutComes: OldOutCome[]
}

// 매치리스트에서 배너 위치를 찾기 위한 tournament match 정보
export interface FlatTournamentMatchInfo {
  tournamentId: number
  tournamentIndex: number
  matchId: number
}

interface SelectedCartParams {
  cartClearCallback?: () => void
  tournamentId: number
  matchId: number
  value: string
}

interface MatchupListState {
  viewControllers: { [id: string]: { [id: string]: ViewController } }
  lastOrderId: string
  hasMore: boolean
  openedAt?: Date
  filteredSelectedDetailTabs?: DETAIL_TAB[]
}

export class MatchupStore extends StoreExt {
  profiler = new Profiler()

  @observable
  club: ClubInfo

  @observable
  unreadClubMessageCount: number

  @observable
  clubOption: ClubOption

  @observable
  clubNoticeHistories: string[]

  rules: ClubRules

  binInfos: ClubBinInfos

  enabledClubLiveLicense = false

  @observable
  cart: CartItem[]

  cloneCart: CartItem[]

  @observable
  betMoney = 0

  @observable
  betCoupon: { [id: string]: number }

  @observable
  betMoneyType = PROPERTY_ID.MONEY

  typeOn: BET_TYPE_ON

  category: MATCHUP_CATEGORY

  @observable
  chargeMoney = 0

  @observable
  collapsedBetSlipBottom = true

  @observable
  collapsedBetSlipSider = true

  @observable
  minimizeBetSlip = true

  @observable
  matchupFilter: MatchupFilterInfo

  @observable
  collapsedChangeRate = true

  @observable
  detailVisibility = false

  @observable
  isBetSlipVisible = false

  @observable
  isBetSlipScrollToTop = false

  @observable
  tracks: TournamentTrack[]


  @observable
  detailTrack: DetailMatchTrack

  @observable
  pageType: PAGE_TYPE

  @observable
  isLoading: boolean

  @observable
  hasMore: boolean

  @observable
  matchChangeHasMore: boolean

  // injectedProps 와 passedProps 가 분리되어 있을 때 매치업 아이템이 여기서 업데이트가 될 때
  // passedProps 로 받게 되는 currentGameKey와 currentSubKey의 업데이트가 안되는 문제가 있어서
  // currentGameKey와 currentSportsKey 도 store 로 옳김
  @observable
  currentGameKey: GAME_TYPE

  @observable
  currentSportsKey: string

  @observable
  currentSportId: number

  @observable
  currentSpecialKey = 100000003

  @observable
  showSpecialGraph = false

  @observable
  categoryTab: number

  @observable
  sportTab: number

  @observable
  majorUniqueID: number

  @observable
  tournamentFilterList: number[]

  @observable
  liveBetCounter: number

  @observable
  recommendMatchCount: number

  @observable
  recommendLeagueCount: number

  @observable
  etcMatchCount: number

  @observable
  etcLeagueCount: number

  @observable
  totalMatchCount: number

  @observable
  totalLiveMatchCount: number

  @observable
  hotMatchCount: number

  // HOT - 전체 핫매치 수, hotMatchCount 와 초기화 시점이 다르다. 화면 표시 시나리오를 대응을 위해 사용한다.
  @observable
  leagueTabHotMatchCount: number

  @observable
  favoriteMatchCount: number

  @observable
  favoriteTotalPreMatchCount: number

  @observable
  processedMatchCount: number

  @observable
  closedMatchCount: number

  @observable
  filteredSelectedDetailTabs: DETAIL_TAB[] = []

  @observable
  filteredProcessedMatchCount: number = undefined

  @observable
  filteredClosedMatchCount: number = undefined

  @observable
  favoriteMatchIds: number[]

  @observable
  progressingMatchCount: number

  @observable
  myBetMatchCount: number

  @observable
  myBetMatchIds: number[]

  @observable
  matchupFilterList: Schema$MatchupFilter[]

  @observable
  filterEventOnly = false

  totalTournamentTracksCount: number

  producerId: ProducerType

  descriptor = ''

  emblemPrefix = ''

  metaSportsDict: { [id: number]: MetaSport }

  metaCategoriesDict: { [id: number]: MetaCategory }

  metaTournamentsDict: { [id: number]: MetaTournament }

  metaTeamsDict: { [id: number]: MetaTeam }

  metaMarketDict: { [id: string]: MetaMarket }

  metaOutcomeDict: { [id: string]: MetaOutcome }

  metaMatchStatusDict: { [id: string]: MetaMatchStatus }

  matches: MatchupItem[]

  lastOrderId: string

  matchChangeLastOrderId: string

  isAlreadyDisplayedUserPrickPromotionBanner: boolean

  matchupBlockBannerVisibleIndex: number

  matchupBlockLeagueFilterBannerVisibleIndex: number // 리그필터일때 띠배너 표시 기준

  @observable
  viewControllers: { [id: string]: { [id: string]: ViewController } }

  majorMatchup: IMatchupItems.Schema

  @observable
  currentSpecialBet: { [sportId: string]: CartItem[] }

  detailMatchId: number

  detailMatchTournamentId: number

  @observable
  majorTournamentFilters: Schema$MajorTournamentFilter[]

  @observable
  cartUpdated: boolean

  selectedCartParams: SelectedCartParams

  matchChangeTournamentTracks: Schema$TournamentTrack[]

  @observable
  matchChangeTournamentTracksStartDate: Date

  @observable
  favoriteMarkets: Schema$FavoriteMarkets   // 유저가 찜한 종목의 마켓타입들

  @observable
  isKeepCart = true   // 베팅 후 베팅슬립 초기화 유무

  @observable
  isBetting = false

  @observable
  selectedBetSlipTabIndexKey = BET_SLIP_TAB_INDEX_KEY.MONEY

  @observable
  useBetSlipRefreshButtonInsteadOfBettingButton = false

  preMatchBetSuccessCountAfterBetSlipOpened = 0

  feedSupplier: FEED_SUPPLIER

  marketProviderData: SportsFeedMarketProvider = {
    pre: null, live: null,
  }

  @observable
  isTournamentTrackLoading = false

  // 토너먼트 트랙 조회시 찜한 경기 정보를 새로 조회해야 할 때 사용한다.
  isNeedToFavoriteMatchIdsWhenFetchTournamentTracks = false

  // MatchTab initializeAllTabState 시점에 기본 탭이 아닌 곳으로 초기화 하고자 할 때 사용한다.
  @observable
  matchTabInitializeMajorUniqueId = null

  // MatchTab initializeAllTabState 시점에 기본 탭이 아닌 곳으로 초기화 하고자 할 때 사용한다.
  @observable
  matchTabInitializeSportId = null

  // 리그 필터용 트랙
  @observable
  filteredTracks: TournamentTrack[]

  matchupListStatus: MatchupListState

  // 종목 탭에서 사용할 메타 정보 (경기 수 정보 포함)
  @observable
  sportTabSports: Schema$MatchupMetaSport[]

  // 추가벳 창에서 detailTrack이 제거되어도, 추가벳 창을 유지해야할지 여부
  @observable
  isKeepMatchDetail = false

  @observable
  matchupDetailPackage: IMatchupDetailPackage.Schema

  // 상세 BET 컨텐츠탭 이동시 사용한다. 탭 표시 개수가 동적이므로 key 를 기반으로 index를 계산한다.
  @observable
  matchupDetailContentTabKey = MATCHUP_DETAIL_CONTENT_TAB_KEY.BET

  flatTournamentTrackMatchInfos: FlatTournamentMatchInfo[] // 매치리스트내 배너 위치 찾을 때 사용

  flatLeagueFilterTournamentTrackMatchInfos: FlatTournamentMatchInfo[] // 리그필터에서 매치 리스트 내 배너 위치를 찾을 때 사용

  isBannerRendered: boolean = false

  scoreRefreshTimer: ReturnType<typeof setTimeout> = null

  scoreRefreshReactionDisposer: IReactionDisposer | null = null

  scoreModeReactionDisposer: IReactionDisposer | null = null

  @observable
  selectedDetailTabs = []

  constructor() {
    super()
    this.setupScoreModeReaction()
    this.cleanup()
  }

  @computed
  get lockedCart(): CartItem[] {
    return _.filter(this.cart, { isLocked: true })
  }

  @computed
  get activeCart(): CartItem[] {
    return _.filter(this.cart, item => !item.isLocked)
  }

  @computed
  get orderedCart(): CartItem[] {
    return [...this.lockedCart, ...this.activeCart]
  }

  @action
  diagnoseFolds = async (params: IDiagnoseFolds.Params): Promise<boolean> => {
    try {
      const { results, errcode } = await this.api.game.doDiagnoseFolds(params)
      if (errcode || _.isEmpty(results)) {
        return false
      }

      let hasNewLock = false
      runInAction(() => {
        for (const res of results) {
          const cartIndex = _.findIndex(this.cart, item => {
            return item.matchId === res.matchId &&
                   item.marketType === res.marketType &&
                   _.isEqual(item.specifiers || {}, res.specifiers || {}) &&
                   item.outcomeMetaId === res.outcomeMetaId
          })

          if (cartIndex > -1) {
            const isLocked = !res.isSuccess
            if (isLocked) hasNewLock = true

            const targetItem = this.cart[cartIndex]
            if (isLocked && this.producerId === ProducerType.PREODDS) {
              this.updateFightingOdds(targetItem.matchId, targetItem.marketType, true)
              this.updateDisabledOdds(targetItem.matchId, targetItem.marketType, targetItem.sportId)
            }

            this.cart.splice(cartIndex, 1, {
              ...this.cart[cartIndex],
              isLocked: isLocked
            })
          }
        }
      })

      this.toggleCartUpdated()
      return hasNewLock
    } catch (err) {
      console.error(err)
      return false
    }
  }

  setupScoreModeReaction = () => {
    if (this.scoreModeReactionDisposer) {
      return
    }

    this.scoreModeReactionDisposer = reaction(
      () => globalStore.findGlobalSetting(GlobalStoreKey.SCORE_MODE_ENABLED)?.value,
      () => {
        if (this.pageType !== PAGE_TYPE.MATCHUP_RESULT && this.pageType !== PAGE_TYPE.MATCHUP_RESULT_FILTER) {
          return
        }

        const defaultTabs = this.getDefaultScorePageDetailTabs()
        this.setSelectedDetailTabs(defaultTabs)
        this.setFilteredSelectedDetailTabs(defaultTabs)
      },
    )
  }

  @action
  setKeepCart = (isKeep: boolean): void => {
    this.isKeepCart = isKeep
  }

  @computed
  get gameKey() {
    return this.currentGameKey
  }

  getMarketProvider(gameType?: GAME_TYPE): MARKET_PROVIDER {
    let currentGameType = gameType
    if (_.isNil(gameType)) {
      currentGameType = this.currentGameKey
    }
    switch (currentGameType) {
      case GAME_TYPE.LIVE:
        return this.marketProviderData.live
      default:
        return this.marketProviderData.pre
    }
  }

  @action
  setSelectedBetSlipTabIndexKey = (key: BET_SLIP_TAB_INDEX_KEY) => {
    this.selectedBetSlipTabIndexKey = key
  }

  @action
  fetchMajorTournamentFilters = async () => {
    try {
      const { filters } = await this.api.game.getMajorTournamentFilters({})
      this.setMajorTournamentFilters(filters)
    } catch (err) {
      console.error(err)
    }
  }

  @action
  setMajorTournamentFilters = (filters: Schema$MajorTournamentFilter[]): void => {
    this.majorTournamentFilters = filters
  }

  @action
  updateDescriptor = () => {
    const newDescriptor = `${this.club.id}:${this.currentGameKey}:${this.currentSportsKey}:`
    this.descriptor = newDescriptor
  }

  @action
  cleanup = (terminate = true) => {
    this.stopScoreRefreshPolling()
    if (this.scoreRefreshReactionDisposer) {
      this.scoreRefreshReactionDisposer()
      this.scoreRefreshReactionDisposer = null
    }
    this.cart = []
    this.betMoney = 0
    this.chargeMoney = 0
    this.collapsedBetSlipBottom = true
    this.collapsedBetSlipSider = true
    this.detailTrack = undefined
    this.detailMatchTournamentId = undefined
    this.collapsedChangeRate = true
    this.detailVisibility = false
    this.viewControllers = {}
    this.useBetSlipRefreshButtonInsteadOfBettingButton = false
    this.preMatchBetSuccessCountAfterBetSlipOpened = 0
    this.isTournamentTrackLoading = false
    this.tournamentFilterList = undefined
    this.setIsKeepMatchDetail(false)
    if (terminate) {
      this.isLoading = false
      this.totalTournamentTracksCount = 0 // x
      this.tracks = [] // x
      this.filteredTracks = []
      this.hasMore = false // x
      this.descriptor = '' // x
      this.emblemPrefix = '' // x
      this.metaSportsDict = {} // x
      this.metaCategoriesDict = {} // x
      this.metaTournamentsDict = {} // x
      this.metaTeamsDict = {} // x
      this.metaMarketDict = {} // x
      this.metaOutcomeDict = {} // x
      this.matches = [] // x
      this.lastOrderId = undefined // x
      this.matchupBlockBannerVisibleIndex = undefined
      this.matchupFilter = { total: 0, major: {}, minor: {}, majorList: [], minorList: [] }
      this.recommendMatchCount = undefined
      this.recommendLeagueCount = undefined // x
      this.etcLeagueCount = undefined // x
      this.matchupFilterList = undefined
      this.matchChangeTournamentTracks = undefined
      this.matchChangeTournamentTracksStartDate = undefined
      this.feedSupplier = undefined
      this.favoriteMatchIds = []
      this.favoriteMatchCount = undefined
      this.myBetMatchCount = undefined
      this.myBetMatchIds = []
      this.hotMatchCount = undefined
      this.leagueTabHotMatchCount = undefined
      this.sportTabSports = undefined
      this.clearMatchListState()
    }

    if (isMobile) {
      this.toggleMinimizeBetSlip(true)
    }
  }

  @action
  clearDetailTrack = () => {
    this.detailTrack = undefined
    this.detailMatchTournamentId = undefined
  }

  makeDetailTrack = (tournamentId: number, track: MatchTrack): DetailMatchTrack => {
    let targetTracks = this.tracks
    if (!_.isNil(this.tournamentFilterList)) {
      targetTracks = this.filteredTracks
    }

    const tour = _.find(targetTracks, { tournamentId })
    if (!tour) {
      this.detailMatchId = undefined
      this.detailTrack = undefined
      this.detailMatchTournamentId = undefined
      return undefined
    }

    const makeTrack: DetailMatchTrack = {
      gameKey: this.currentGameKey,

      sportId: tour.sportId,
      categoryId: tour.categoryId,
      tournamentId: tour.tournamentId,

      sportName: tour.sportName,
      categoryName: tour.categoryName,
      tournamentName: tour.tournamentName,

      sportEmblem: tour.sportEmblem,
      categoryEmblem: tour.categoryEmblem,
      tournamentEmblem: tour.tournamentEmblem,

      track,
    }

    return makeTrack
  }

  @action
  setDetailTrack = (tournamentId: number, track: MatchTrack, pageType?: PAGE_TYPE) => {
    const newTrack = this.makeDetailTrack(tournamentId, track)
    if (!newTrack) {
      return newTrack
    }

    this.detailMatchId = track.matchId
    this.detailMatchTournamentId = tournamentId
    this.detailTrack = newTrack
    this.pageType = pageType
    //this.clearDetailCart()
    return newTrack
  }

  @action
  setPageType = (pageType: PAGE_TYPE): void => {
    this.pageType = pageType
  }

  getDefaultScorePageDetailTabs = (): DETAIL_TAB[] => {
    if (globalStore.getScoreModeEnabled()) {
      return [DETAIL_TAB.PROCESSED, DETAIL_TAB.CLOSED]
    }

    return [DETAIL_TAB.CLOSED]
  }

  getActiveScorePageDetailTabs = (useFiltered = false): DETAIL_TAB[] => {
    if (!globalStore.getScoreModeEnabled()) {
      return [DETAIL_TAB.CLOSED]
    }

    return useFiltered ? this.filteredSelectedDetailTabs : this.selectedDetailTabs
  }

  @action
  setSpecialKey = (key: number) => {
    this.currentSpecialKey = key
  }

  @action
  toggleSpecialGraphVisible = () => {
    this.showSpecialGraph = !this.showSpecialGraph
    return this.showSpecialGraph
  }

  @action
  setShowSpecialGraph = value => {
    this.showSpecialGraph = value
  }

  @action
  testChangeRate = async (cart: CartItem[], isChangeRateAction = false) => {
    const matchData: { [id: string]: ProducerType } = {}
    for (const el of cart) {
      matchData[el.matchId] = el.producerId
    }

    const { matches } = await this.api.game.getUpdateGame({
      clubId: this.club.id,
      matchData: matchData,
    })

    for (const el of matches) {
      const idx = _.findIndex(this.matches, { matchId: el.matchId })
      if (idx >= 0) {
        this.matches[idx] = el
      }
    }

    this.fetchChangeRate(cart, matches, isChangeRateAction)
  }

  // NOTE:이전 배당률을 새로운 배당률로 변경
  @action
  changeOutcomeRate = (oldOutCome: Schema$Outcome, newOutCome: Schema$Outcome) => {
    oldOutCome.oldRate = oldOutCome.rate
    oldOutCome.rate = newOutCome.rate
  }

  // NOTE: 메인페이지에서 베팅한 MarketType만 배당률 변경
  // 하나의 마켓타입의 모든 배당률을 변경
  @action
  updateOneMarketChangeRate = (marketBlock: Schema$MarketBlock, newblock: Schema$MarketBlock) => {
    marketBlock.oldSpecifiers = marketBlock.specifiers
    marketBlock.specifiers = newblock.specifiers
    for (const oldOutCome of marketBlock.outcomes) {
      const newOutCome = _.find(newblock.outcomes, { type: oldOutCome.type })
      if (newOutCome) {
        this.changeOutcomeRate(oldOutCome, newOutCome)
      }
    }
  }

  // NOTE : 베팅시 배당률이 바뀌면 상세페이지는 전체 갱신을 위해 모든 배당률 변경
  // 한 경기의 메인 배당률 전체를 바꾸는것도 가능 regulars
  @action
  updateIrregualrsChangeRate = (marketTracks: Schema$MarketTrack[], newMarket: Schema$MatchupMarket) => {
    for (const mTrack of marketTracks) {
      // 한 경기의 베팅할 수 있는 markets
      for (const mMarket of mTrack.markets) {
        // 한 market의 베팅할 수 있는 outcomes
        const newBlocks = newMarket.markets[mMarket.type]
        if (newBlocks) {
          const newBlock = _.find(newBlocks, { specifiers: mMarket.specifiers })
          if (newBlock) {
            this.updateOneMarketChangeRate(mMarket, newBlock)
          }
        }
      }
    }
  }

  @action
  updateSelectedCartValue = (cart: CartItem) => {
    const elems = cart.value.split('//')
    if (elems.length > 0) {
      elems[3] = cart.rate.toString()
      let newElems = ''
      elems.forEach((event, index) => {
        if (index !== 0) {
          newElems = newElems.concat('//')
        }
        newElems = newElems.concat(event)
      })

      cart.value = newElems
    }
  }

  @action
  fetchChangeRate = (cart: CartItem[], matches: MatchupItem[], isChangeRateAction: boolean) => {
    // add dat to cart
    // TODO tournamentTracks 활용 방법
    for (const el of cart) {
      const found = _.find(matches, { matchId: el.matchId })
      if (found) {
        const foundMarketList = found.markets[el.marketType]
        if (foundMarketList) {
          const { specifiers = {} } = el
          const block = _.find(foundMarketList, o => {
            return _.isEqual(specifiers, o.specifiers)
          })
          if (block.marketProvider !== this.getMarketProvider()) {
            continue
          }
          if (block) {
            const outcome: Schema$Outcome = _.find(block.outcomes, { type: el.selection })
            // NOTE: tracks는 오로지 프론트매치업 용으로 사용한다.
            // 상세페이지에 접근하면 tracks데이타를 모두 날리고 detailTrack에 정보를 담는다.

            const trackUpdater = (targetTracks: TournamentTrack[]) => {
              if (targetTracks.length > 0) {
                _.forEach(targetTracks, track => {
                  if (track.tournamentId === el.tournamentId) {
                    const matchTrack = _.find(track.matches, { matchId: el.matchId })
                    if (matchTrack) {
                      const marketTrack = _.find(matchTrack.regulars, { type: el.marketType })
                      // 1. marketTrack.markets에서 type만 가지고 find를 하면 같은 타입이 여러개 들어 가 있는경우
                      // 언더오버, 핸디캡의 경우에는 무조건 첫번째의 object만을 리턴하게 됨
                      // find 조건에 specifiers 추가
                      // [참조](http://prj.iventory.co.kr:5000/view.php?id=5976)

                      // 2. 믹스베팅 추가된 후, 매치 리스트에 표시되지 않은 경기의 배당 변경도 갱신한다.
                      // 현재 화면에 표시된 tracks 를 기반으로 배당 변경을 적용하고자 할 때,
                      // 프리, 라이브에 동일 경기가 모두 존재하는 경우 (ex. 18:00 야구 프리매치 + 시작전 야구 라이브매치)
                      // matchTrack 을 찾지만 marketTrack은 찾을 수 없기 때문에 존재하는 경우만 로직 실행 되도록 방어코드 작성함.
                      if (marketTrack) {
                        const marketChildTrack = _.find(marketTrack.markets, {
                          type: Number(el.marketType),
                          specifiers: block.specifiers,
                        })
                        this.updateOneMarketChangeRate(marketChildTrack, block)
                      }
                      if (!_.isNil(this.detailTrack)) {
                        this.updateIrregualrsChangeRate(this.detailTrack.track.irregulars, found)
                      }
                    }
                  }
                })
              }
            }

            trackUpdater(this.tracks)
            trackUpdater(this.filteredTracks)

            if (outcome && outcome.rate && outcome.rate !== el.rate) {
              if (isChangeRateAction) {
                el.cartId = uuid.v4()
                el.changeRate = {
                  homeTeamName: el.match.homeTeamName,
                  awayTeamName: el.match.awayTeamName,
                  marketType: el.marketType,
                  specifier: el.specifiers,
                  from: { type: el.selection, rate: el.rate, metaId: el.outcomeMetaId },
                  to: _.clone(outcome),
                }
              }
              el.rate = outcome.rate
              this.updateSelectedCartValue(el)
            }
          }
        }
      }
    }
    this.toggleCartUpdated()
    if (isChangeRateAction) {
      this.toggleChangeRateCollapsed(false)
    }

    this.tracks = [].concat(this.tracks)
  }

  // ui 를 변경하는 테스트 함수
  @action
  test = (tournamentId: number, matchId: number, marketType: string) => {
    const tourFound = _.find(this.tracks, { tournamentId })
    const maFound = _.find(tourFound.matches, { matchId })
    if (maFound) {
      for (const markets of maFound.regulars) {
        if (markets.type === marketType) {
          for (const market of markets.markets) {
            for (const outcome of market.outcomes) {
              const newOutcome = outcome.rate * 2
              outcome.rate = newOutcome
            }
          }
        }
      }

      // ui 에게 변경을 요청
      // window.postMessage(
      //   {
      //     type: 'vc',
      //     key: 'updateField',
      //     value: {
      //       matchId: maFound.matchId,
      //     },
      //   },
      //   undefined,
      // )

      const vcMatch = this.viewControllers[maFound.matchId]
      if (vcMatch) {
        for (const key in vcMatch) {
          vcMatch[key].updateField()
        }
      }
    }
  }

  @action
  fetchMatchupDetailFilters = async (sportId: number): Promise<MatchupDetailFilter[]> => {
    try {
      let filters
      const result = await this.api.game.getMatchupDetailFilters({ sportId })
      if (result) {
        filters = result.filters
      }
      return filters
    } catch (err) {
      console.error(err)
      message.warn('상세 BET 필터를 정상적으로 불러오지 못하였습니다.')
    }
    return []
  }

  // NOTE: 새로 갱신되었을 경우 이전에 받은 데이터의 oldrate값을 유지하기위한 func 배당률 애니메이션과 연관있음 라이브전용
  //       상세페이지만 적용
  @action
  updateOldRateMarkets = (curMarkets: Schema$MarketTrack[], oldMarkets: Schema$MarketTrack[]) => {
    for (const market of oldMarkets) {
      const markets = curMarkets.find(e => e.type === market.type && e.name === market.name)
      if (markets) {
        for (const oldblock of market.markets) {
          const targetBlock = markets.markets.find(
            e => e.type === oldblock.type && _.isEqual(e.specifiers, oldblock.specifiers),
          )
          if (targetBlock) {
            for (const outcome of oldblock.outcomes) {
              const outcomeField = targetBlock.outcomes.find(e => e.type === outcome.type)
              if (outcomeField) {
                outcomeField.oldRate = outcome.oldRate
              }
            }
          }
        }
      }
    }
  }

  @action
  updateMatchupDetailMarkets = (
    matchId: number, producerId: number, isLive = false, detailMatchTrack?: DetailMatchTrack,
  ): void => {
    if (detailMatchTrack) {
      this.producerId = producerId
      this.detailMatchId = matchId
      this.detailTrack = detailMatchTrack
      this.detailMatchTournamentId = detailMatchTrack.tournamentId
    } else {
      let tournamentId = null
      let foundMatch: Schema$MatchTrack = null
      for (const track of this.tracks) {
        foundMatch = track.matches.find((match) => {
          return match.matchId === matchId
        })

        if (foundMatch) {
          tournamentId = track.tournamentId
          break
        }
      }

      if (foundMatch) {
        const newDetailTrack = this.makeDetailTrack(tournamentId, foundMatch)
        if (newDetailTrack) {
          if (isLive) {
            if (!_.isNil(this.detailTrack)) {
              this.updateOldRateMarkets(newDetailTrack.track.irregulars, this.detailTrack.track.irregulars)
            }
          }

          this.producerId = producerId
          this.detailMatchId = matchId
          this.detailTrack = newDetailTrack
          this.detailMatchTournamentId = newDetailTrack.tournamentId
        }
      }
    }
  }

  fetchMatchupDetailPackage = async (params: {
    matchId: number,
    sportId: number
  }): Promise<IMatchupDetailPackage.Schema> => {
    try {
      const { matchId, sportId } = params
      if (_.isNil(matchId)) {
        this.setMatchupDetailPackage(null)
        return
      }

      const result = await this.api.game.getMatchupDetailPackage({ matchId, sportId })
      Mining.sortOutcome(BET_TYPE_ON.UNIFIED_MATCH, result.outcomes)
      this.setMatchupDetailPackage(result)
    } catch (err) {
      console.error(err)
    }
  }

  @action
  setMatchupDetailPackage(detailPackage: IMatchupDetailPackage.Schema) {
    this.matchupDetailPackage = detailPackage
  }

  @action
  fetchMatchupDetailMarkets = async (params: IMatchupDetailMarkets.Params, isLive = false): Promise<boolean> => {
    try {
      this.producerId = params.producerId
      const tournamentId = params.tournamentId
      const result = await this.api.game.getMatchupDetailMarkets(params)
      const { error } = result
      if (!result || error === DUPLICATE_REQUEST_EXCEPTION) {
        return false
      }
      runInAction(() => {
        const detailTrack = this.makeDetailTrack(params.tournamentId, result.track)
        if (!isLive) {
          this.detailMatchId = params.matchId
          this.detailTrack = detailTrack
          this.detailMatchId = detailTrack?.track?.matchId
          this.detailMatchTournamentId = tournamentId

          const found = _.find(this.cart, cartItem => {
            return cartItem.matchId == this.detailMatchId
          })
          if (!_.isEmpty(found)) {
            for (const cartItem of this.cart) {
              const {
                matchId,
                marketType,
                sportId,
                value,
              } = cartItem
              this.updateFightingOdds(matchId, marketType, false)
              this.updateDisabledOdds(matchId, marketType, sportId, value)
            }
          }
        } else {
          const cloneTrack = detailTrack
          // NOTE : 라이브의 경우 10초마다 오즈마켓 정보를 갱신시켜주는데 orlRate만 이전의 데이터로 유지시켜주고
          //        나머지는 새로받은 데이터로 갱신시켜준다.
          if (!_.isNil(this.detailTrack)) {
            this.updateOldRateMarkets(cloneTrack.track.irregulars, this.detailTrack.track.irregulars)
          }

          this.detailTrack = cloneTrack
          this.detailMatchTournamentId = tournamentId

          this.updateTrackMarketStatus(cloneTrack)
        }
      })

      return true
    } catch (err) {
      console.error(err)
      message.warn('상세 BET 페이지를 정상적으로 불러오지 못하였습니다.')
      return false
    } finally {
      this.setIsKeepMatchDetail(false)
    }
  }

  @action
  updateTrackMarketStatus = (detailTrack: DetailMatchTrack) => {
    if (_.isEmpty(detailTrack)) {
      return
    }
    const { tournamentId, gameKey } = detailTrack

    const targetTrack = _.find(this.tracks, track => track.tournamentId === tournamentId)
    if (!targetTrack) {
      return
    }
    const targetMatch = _.find(targetTrack.matches, match => match.matchId === detailTrack.track?.matchId)
    if (!targetMatch) {
      return
    }

    for (const irregular of detailTrack.track.irregulars) {
      const filteredDetailMarkets
        = _.filter(irregular.markets, market => _.includes(GAME_TYPE_REGULAR_FILTER[gameKey], market.type.toString()))

      for (const detailMarket of filteredDetailMarkets) {
        for (const regular of targetMatch.regulars) {
          const targetMarket = _.find(regular.markets, market => market.type === detailMarket.type)
          if (targetMarket) {
            targetMarket.status = detailMarket.status
          }
        }
      }
    }
  }

  refreshClubOption = async (betMoneyType: PROPERTY_ID = this.betMoneyType) => {
    const { clubOption } = await this.api.club.getClubOption({ clubId: this.club.id, betMoneyType })
    runInAction(() => {
      this.clubOption = clubOption
    })
  }

  @action
  cartChangeRate = (origins: CartItem[], cloneCart: CartItem[]) => {
    for (let i = origins.length - 1; i >= 0; i -= 1) {
      const cloneTarget = cloneCart.find(e => {
        return e.matchId === origins[i].matchId && e.marketType === origins[i].marketType
      })
      if (cloneTarget) {
        origins[i].changeRate = undefined
        if (!_.isNil(origins[i].rate) && !_.isNil(cloneTarget.rate) && origins[i].rate !== cloneTarget.rate) {
          origins[i].cartId = uuid.v4()
          origins[i].changeRate = {
            homeTeamName: origins[i].match.homeTeamName,
            awayTeamName: origins[i].match.awayTeamName,
            marketType: origins[i].marketType,
            specifier: origins[i].specifiers,
            from: { type: cloneTarget.selection, rate: cloneTarget.rate, metaId: cloneTarget.outcomeMetaId },
            to: { type: origins[i].selection, rate: origins[i].rate, metaId: origins[i].outcomeMetaId },
          }
        }
      }
    }
    this.toggleChangeRateCollapsed(false)
  }

  @action
  isLiveBettingRateCheck = (origins: CartItem[], cloneCart: CartItem[]) => {
    let isChangeRate = false
    for (let i = origins.length - 1; i >= 0; i -= 1) {
      const cloneTarget = cloneCart.find(e => {
        return e.matchId === origins[i].matchId && e.marketType === origins[i].marketType
          && e.producerId === ProducerType.LIVEODDS
      })
      if (cloneTarget) {
        if (!_.isNil(origins[i].rate) && !_.isNil(cloneTarget.rate) && origins[i].rate !== cloneTarget.rate) {
          isChangeRate = true
          break
        }
      }
    }

    return isChangeRate
  }

  getBetCallCategory = (category: MATCHUP_CATEGORY, marketType: string) => {
    let betcall_category = category
    const isMainMarket = this.isMainMarket(marketType)

    switch (category) {
      case MATCHUP_CATEGORY.CROSS:
      case MATCHUP_CATEGORY.WIN_DRAW_LOSE:
      case MATCHUP_CATEGORY.HANDICAP:
        if (!isMainMarket) {
          betcall_category = MATCHUP_CATEGORY.MATCH_DETAIL
        }
        break
      case MATCHUP_CATEGORY.LIVE:
        if (!isMainMarket) {
          betcall_category = MATCHUP_CATEGORY.LIVE_DETAIL
        }
        break
      case MATCHUP_CATEGORY.MIX:
        betcall_category = MATCHUP_CATEGORY.MIX
        break
    }

    return betcall_category
  }

  @action
  betCommon = async (
    orgCart: CartItem[],
    betMoney: number,
    betMoneyType: number,
    regular: boolean,
    funcSucceed?: () => void,
  ) => {
    try {
      if (this.isBetting) {
        return
      }

      if (betMoney === 0) {
        showToast(TOAST_TYPE.INFO, '베팅머니를 입력하세요.')
        return
      }

      if (_.isNil(orgCart) || orgCart.length === 0) {
        return
      }

      // 라이브 베팅시 배당이 바뀌면 cart에 담겨진 배당도 바껴서 베팅이 가능한 문제 때문에
      // cart의 원본을 복사해서 쓴다.
      if (this.producerId === ProducerType.LIVEODDS) {
        this.cloneCart = _.cloneDeep(orgCart)
      } else {
        this.cloneCart = orgCart
      }

      const splitted = this.descriptor.split(':')
      const [clubId] = splitted

      // 베팅 룰 사전 검사 - 서버에서만 체크 하도록 수정.
      // const ret = canGameTypesFoldCount(gameKey, cart.length, this.rules)
      // if (!ret.allowed) {
      //   globalStore.closeDialog()
      //   globalStore.pushDialogOk({ title: '알림', text: [ret.message] })
      //   return
      // }
      // 베팅 룰 검사 끝

      let typeOn = BET_TYPE_ON.UNIFIED_MATCH
      let category = MATCHUP_CATEGORY.CROSS

      const gameKeys = _.uniq(_.map(orgCart, cart => cart.gameKey))
      if (_.size(gameKeys) > 1) {
        typeOn = BET_TYPE_ON.MIX
        category = MATCHUP_CATEGORY.MIX
      } else {
        switch (gameKeys[0]) {
          case GAME_TYPE.CROSS:
            category = MATCHUP_CATEGORY.CROSS
            break
          case GAME_TYPE.WAY:
            category = MATCHUP_CATEGORY.WIN_DRAW_LOSE
            break
          case GAME_TYPE.UO:
            category = MATCHUP_CATEGORY.HANDICAP
            break
          case GAME_TYPE.LIVE:
            typeOn = BET_TYPE_ON.UNIFIED_LIVE
            category = MATCHUP_CATEGORY.LIVE
            break
          case GAME_TYPE.SPECIAL:
            typeOn = BET_TYPE_ON.UNIFIED_SPECIAL
            category = MATCHUP_CATEGORY.SPECIAL
            break
        }
      }

      this.typeOn = typeOn
      this.category = category

      if (typeOn === BET_TYPE_ON.UNIFIED_LIVE
        || typeOn === BET_TYPE_ON.MIX) {
        const betLimitScoreInfoMap = globalStore.getBetLimitScoreInfoMap()

        for (const cart of orgCart) {
          const { sportId, marketType, match } = cart
          const { matchStatusCode, homeScore, awayScore, periodScores } = match
          const betLimitScoreInfo = betLimitScoreInfoMap[sportId]

          if (!validateBetLimitScore({
            marketType: _.toNumber(marketType),
            matchStatusCode,
            homeScore,
            awayScore,
            periodScores,
            betLimitScoreInfo,
          })) {
            showToast(TOAST_TYPE.INFO, `베팅 도중 베팅 상태가 변경되었습니다. 다시 시도해 주세요.`)
            return
          }
        }
      }

      const callType = this.cloneCart.length > 1 ? BET_CALL_TYPE.MULTI : BET_CALL_TYPE.SINGLE
      const betCalls: Schema$BetCall[] = []

      for (const el of this.cloneCart) {
        const bc: Schema$BetCall = {
          typeOn,
          category: this.getBetCallCategory(category, el.marketType),
          callType,
          matchId: el.match.matchId,
          sportId: el.sportId,
          categoryId: el.categoryId,
          tournamentId: el.tournamentId,
          homeTeamId: el.match.homeTeamId,
          awayTeamId: el.match.awayTeamId,
          marketId: el.marketId,
          marketType: el.marketType,
          specifiers: el.specifiers,
          selection: el.selection,
          outcomeMetaId: el.outcomeMetaId,
          outcomeRate: el.rate.toString(),
          betMoney,
          betMoneyType,
          feedSupplier: this.feedSupplier,
          marketProvider: this.getMarketProvider(gameKeys[0]),
          producerId: el.producerId,
        }
        betCalls.push(bc)
      }

      const { appVersion, selectedUserExtraOddsItem } = componentStore

      const params: IBet.Params = {
        clubId,
        typeOn,
        category,
        betCalls,
        betMoneyType,
        appVersion,
        feedSupplier: this.feedSupplier,
        marketProvider: this.marketProviderData.pre,
        liveMarketProvider: this.marketProviderData.live,
      }

      if (isExtraOddsItemSupportBetMoneyType(betMoneyType)) {
        _.extend(params, { extraOddsItemPropertyId: selectedUserExtraOddsItem?.propertyId })
      }

      runInAction(() => {
        this.isBetting = true
        globalStore.pushDialogWait({ wrapClassName: 'betting-dialog-wait', className: 'none' }) /* 투명 레이어 */
      })

      if (category === MATCHUP_CATEGORY.LIVE) {
        await this.fireLiveBet(params, this.cloneCart, orgCart, params.typeOn, betMoneyType, funcSucceed)
      } else if (category === MATCHUP_CATEGORY.MIX) {
        await this.fireMixBet(params, this.cloneCart, orgCart, params.typeOn, betMoneyType, funcSucceed)
      } else {
        await this.fireBet(params, this.cloneCart, orgCart, params.typeOn, betMoneyType, funcSucceed)
      }

      runInAction(() => {
        this.isBetting = false
        globalStore.closeDialog()
      })
    } catch (err) {
      runInAction(() => {
        globalStore.closeDialog()
        console.error(err)
        showToast(TOAST_TYPE.INFO, `서버 연결이 원활하지 않습니다. 새로고침해 주세요. (${JSON.stringify(err)})`)
        this.isBetting = false
      })
    }
  }

  @action
  liveBetResultError = async (errcode: number) => {
    const errText = getErrorText(errcode) || '서버 연결이 원활하지 않습니다. 새로고침해 주세요.'
    console.log('liveBetResultError', errcode)
    const detailTournamentId = this.detailMatchTournamentId ? _.clone(this.detailMatchTournamentId) : undefined

    let copiedMyBetMatchId = []
    if (this.majorUniqueID === EXCEPTIONAL_UNIQUE_ID.MY_BET_MATCH) {
      copiedMyBetMatchId = _.clone(this.myBetMatchIds)
    }
    switch (errcode) {
      case ERR.BET_FAIL_DIFFRENT_RATE:
        globalStore.showBubblePopupTimer(BubbleTextType.DEFAULT_ALERT, errText, BubbleType.BET_SLIP)
        // 라이브 페이지에서는 오즈 서버 데이터로 항상 최신 데이터이므로 현재 카트와 베팅 시점 카트로 배당 차이를 표시한다.
        if (isViewPage(PAGE_TYPE.LIVE) && this.isLiveBettingRateCheck(this.cart, this.cloneCart)) {
          this.cartChangeRate(this.cart, this.cloneCart)
        } else {
          await this.testChangeRate(this.cart, true)
        }
        break
      case ERR.BET_FAIL_LESSER_BETTING_MIN:
      case ERR.BET_FAIL_GREATER_BETTING_MAX: {
        await this.refreshClubOption()
        const club_bet = getClubMinMaxBet(this.typeOn, this.betMoneyType, this.clubOption)
        globalStore.showBubblePopupTimer(
          BubbleTextType.DEFAULT_ALERT,
          getMixMaxBetError(errText, club_bet.betmoney_min, club_bet.betmoney_max),
          BubbleType.BET_SLIP,
        )
        break
      }
      case ERR.BET_FAIL_PRE_MATCH_STARTED:
      case ERR.BET_FAIL_INACTIVE_LIVE:
      case ERR.BET_FAIL_INVALID_LIVEODDS:
      case ERR.BET_FAIL_LESS_THEN_MINIMUM_LIVE_MATCH_OUTCOME_RATE:
      case ERR.BET_FAIL_ALREADY_OUTCOME:
      case ERR.BET_FAIL_INACTIVE_MARKET:
      case ERR.BET_FAIL_FEED_SYSTEM_DELAYED: {
        const betCalls: IDiagnoseFolds.BetCall[] = this.cart.map(item => ({
          matchId: item.matchId,
          marketType: item.marketType,
          specifiers: item.specifiers || {},
          outcomeMetaId: item.outcomeMetaId,
          selection: item.selection,
          feedSupplier: this.feedSupplier,
          marketProvider: this.getMarketProvider(),
          producerId: item.producerId
        }))
        const diagnoseParams = { clubId: this.club.id, betCalls }
        const isLocked = await this.diagnoseFolds(diagnoseParams)

        if (isLocked) {
          showToast(TOAST_TYPE.INFO, '베팅 타입이 잠겼습니다. 베팅슬립을 확인해주세요.')
          this.setBetSlipScrollToTop(true)
        } else {
          showToast(TOAST_TYPE.INFO, errText)
        }

        runInAction(() => {
          if (!_.isEmpty(copiedMyBetMatchId)) {
            this.myBetMatchIds = copiedMyBetMatchId
          }
          if (detailTournamentId) {
            this.setIsKeepMatchDetail(true)
          }
        })

        if (this.gameKey === GAME_TYPE.LIVE) {
          await this.fetchTournamentTracks({ limit: 999, reset: true, pageType: PAGE_TYPE.LIVE })
        } else {
          await this.fetchTournamentTracks({ limit: 20, reset: true, pageType: PAGE_TYPE.MATCHUP })
        }

        if (this.tracks && detailTournamentId) {
          this.fetchMatchupDetailMarkets({
            gameType: this.currentGameKey,
            clubId: this.club.id,
            producerId: this.producerId,
            matchId: this.detailMatchId,
            tournamentId: detailTournamentId,
          }, this.gameKey === GAME_TYPE.LIVE)
        }
        break
      }
      case ERR.BET_FAIL_GREATER_HIT_MAX:
        await this.refreshClubOption()
        this.clubOption.hit_max = this.betMoneyType === PROPERTY_ID.NEW_BET_TICKET_G
          ? this.clubOption.hit_max / RATIO_TICKET : this.clubOption.hit_max
        globalStore.showBubblePopupTimer(BubbleTextType.DEFAULT_ALERT, `${errText}(${formatNumber(this.clubOption.hit_max)})`, BubbleType.BET_SLIP)
        break
      case ERR.BET_FAIL_GREATER_LIMIT_BETTING_RATE:
        await this.refreshClubOption()
        globalStore.showBubblePopupTimer(BubbleTextType.DEFAULT_ALERT, `${this.clubOption.limit_betting_rate}배 이상 베팅하실 수 없습니다.`, BubbleType.BET_SLIP)
        break
      case ERR.BET_FAIL_UNAVAILABLE_CROSS_SINGLE_BET:
      case ERR.BET_FAIL_UNAVAILABLE_WDL_SINGLE_BET:
      case ERR.BET_FAIL_UNAVAILABLE_HANDI_UN_OVER_SINGLE_BET:
        await this.showOneFoldPopupOrErrTextToast(BET_TYPE_ON.UNIFIED_MATCH, errText)
        break
      case ERR.BET_FAIL_UNAVAILABLE_SPECIAL_SINGLE_BET:
        await this.showOneFoldPopupOrErrTextToast(BET_TYPE_ON.UNIFIED_SPECIAL, errText)
        break
      case ERR.BET_FAIL_UNAVAILABLE_LIVE_SINGLE_BET:
        await this.showOneFoldPopupOrErrTextToast(BET_TYPE_ON.UNIFIED_LIVE, errText)
        break
      case ERR.BET_FAIL_EXCEEDED_MATCH_SCORE:
        showToast(TOAST_TYPE.INFO, `베팅 도중 베팅 상태가 변경되었습니다. 다시 시도해 주세요.`)
        break
      case ERR.BET_FAIL_INSUFFICIENT_MONEY: {
        const convertedErrText = getErrorTextByBetMoneyType(errText, this.betMoneyType)
        globalStore.showBubblePopupTimer(BubbleTextType.DEFAULT_ALERT, convertedErrText, BubbleType.BET_SLIP)
        break
      }
      default:
        globalStore.showBubblePopupTimer(BubbleTextType.DEFAULT_ALERT, errText, BubbleType.BET_SLIP)
        break
    }
  }

  isEnabledSingleBet = (propertyId: PROPERTY_ID): boolean => {
    let enabled = false
    switch (propertyId) {
      case PROPERTY_ID.MONEY:
        enabled = authStore.userInfo.moneySingleBetEnabled
        break
      case PROPERTY_ID.DIA:
        enabled = authStore.userInfo.diaSingleBetEnabled
        break
      case PROPERTY_ID.NEW_BET_TICKET_G:
        enabled = authStore.userInfo.betTicketSingleBetEnabled
        break
    }
    return enabled
  }

  private existsLockedFolds = (cart: CartItem[]): boolean => {
    if (_.some(cart, { isLocked: true })) {
      showToast(TOAST_TYPE.INFO, '잠긴 베팅 타입은 베팅할 수 없습니다.')
      return true
    }
    return false
  }

  @action
  fireLiveBet = async (
    params: IBet.Params,
    cart: CartItem[],
    orgCart: CartItem[],
    typeOn: BET_TYPE_ON,
    betMoneyType: number,
    funcSucceed?: () => void,
  ) => {
    if (this.existsLockedFolds(cart)) return

    if (params.betCalls.length === 1 && !this.isEnabledSingleBet(params.betMoneyType)) {
      const errText = getErrorText(ERR.BET_FAIL_SINGLE_BET_WITH_ADMIN_CONFIG)
      globalStore.showBubblePopupTimer(BubbleTextType.DEFAULT_ALERT, errText, BubbleType.BET_SLIP)
      return
    }

    const {
      errcode,
      settlementSupport,
      userConditionState,
    } = await this.api.game.doliveBet(params)

    if (errcode) {
      await this.liveBetResultError(errcode)
      return
    }

    await this.checkChangeRate(cart)
    this.updateSettlementSupport(settlementSupport)
    this.showSettlementSupportPopup(settlementSupport)
    this.mobileAppRecordEventByFirstBet(userConditionState?.isFirstBetByCivalue ?? false)
    this.updateMyBetMatchInfo(params.betCalls)
  }

  @action
  fireMixBet = async (
    params: IBet.Params,
    cart: CartItem[],
    orgCart: CartItem[],
    typeOn: BET_TYPE_ON,
    betMoneyType: number,
    funcSucceed?: () => void,
  ) => {
    if (this.existsLockedFolds(cart)) return

    const {
      errcode,
      settlementSupport,
      userConditionState,
    } = await this.api.game.doMixBet(params)

    if (errcode) {
      await this.liveBetResultError(errcode)
      return
    }

    await this.checkChangeRate(cart)
    this.updateSettlementSupport(settlementSupport)
    this.showSettlementSupportPopup(settlementSupport)
    this.mobileAppRecordEventByFirstBet(userConditionState?.isFirstBetByCivalue ?? false)
    this.updateMyBetMatchInfo(params.betCalls)
  }

  @action
  updateMyBetMatchInfo = (betCalls: Schema$BetCall[]) => {
    runInAction(() => {
      const matchIds = Array.from(new Set(_.map(betCalls, 'matchId')))
      const newMatchIds = _.concat(this.myBetMatchIds, matchIds)
      this.myBetMatchIds = [].concat(Array.from(new Set(newMatchIds)))
      this.myBetMatchCount = _.size(this.myBetMatchIds)
    })
  }

  updateSettlementSupport = (settlementSupport: SettlementSupport): void => {
    if (_.isEmpty(settlementSupport)) {
      return
    }

    const currentSettlementSupport = userStore.settlementSupport
    currentSettlementSupport.achieveGoalValue = settlementSupport.achieveGoalValue
    currentSettlementSupport.totalBetMoney = settlementSupport.totalBetMoney
    userStore.setSettlementSupport(currentSettlementSupport)
  }

  showSettlementSupportPopup = (settlementSupport: SettlementSupport): void => {
    if (_.isEmpty(settlementSupport)) {
      return
    }

    if (settlementSupport.showFirstBetPopup) {
      globalStore.setVisibleFirstBetPopup(true)
      this.googleAdsEventSuccessFirstBet()
    } else if (settlementSupport.showAchieveGoalPopup) {
      globalStore.setVisibleAchieveGoalPopup(true)
    } else if (settlementSupport.showVocPopup) {
      globalStore.setVisibleVocPopup(true)
    }
  }

  checkChangeRate = async (cart: CartItem[]): Promise<void> => {
    const liveBetDelayStep = JSON.parse(
      globalStore.findGlobalSetting(GlobalStoreKey.LIVE_BET_DELAY_SEC_PER_TOURNAMENT)?.value ?? '{}',
    )

    const KEY_BET_DELAY_DEFAULT = 'default'
    const defaultDelayStep = _.has(liveBetDelayStep, KEY_BET_DELAY_DEFAULT)
      ? liveBetDelayStep[KEY_BET_DELAY_DEFAULT] : 0
    let delayTime = defaultDelayStep

    for (const index in cart) {
      const tournamentId = cart[index].tournamentId.toString()
      const tournamentStep = _.has(liveBetDelayStep, tournamentId) ? liveBetDelayStep[tournamentId] : -1

      if (tournamentStep > -1) {
        delayTime = tournamentStep
      } else {
        delayTime = defaultDelayStep
      }
    }

    for (let i = delayTime; i >= 1; i -= 1) {
      // NOTE : 라이브 경기의 경우 베팅순간 깊은복사한 cart와 실시간으로 바뀌는 cart와 비교
      if (this.isLiveBettingRateCheck(this.cart, cart)) {
        this.cartChangeRate(this.cart, cart)
        // eslint-disable-next-line no-await-in-loop
        const res = await this.api.game.doliveBetCancel()
        if (res.errcode != null) {
          const errText = getErrorText(res.errcode) || '서버 연결이 원활하지 않습니다. 새로고침해 주세요.'
          showToast(TOAST_TYPE.INFO, errText)
        } else {
          globalStore.showBubblePopupTimer(
            BubbleTextType.DEFAULT_ALERT,
            getErrorText(ERR.BET_FAIL_DIFFRENT_RATE),
            BubbleType.BET_SLIP,
          )
        }
        break
      }
      // eslint-disable-next-line no-await-in-loop
      await sleep(1000)
    }
  }


  @action
  fireBet = async (
    params: IBet.Params,
    cart: CartItem[],
    orgCart: CartItem[],
    typeOn: BET_TYPE_ON,
    betMoneyType: number,
    funcSucceed?: () => void,
  ) => {
    if (this.existsLockedFolds(cart)) {
      return
    }

    if (params.betCalls.length === 1) {
      if (!this.isEnabledSingleBet(params.betMoneyType)) {
        const errText = getErrorText(ERR.BET_FAIL_SINGLE_BET_WITH_ADMIN_CONFIG)
        globalStore.showBubblePopupTimer(BubbleTextType.DEFAULT_ALERT, errText, BubbleType.BET_SLIP)
        return
      }
      this.setBetParamsSinglePenalty(params)
    }

    const {
      errcode,
      club,
      user,
      settlementSupport,
      userConditionState,
    } = await this.api.game.doBet(params)

    if (errcode) {
      console.log('fireBet error', errcode)
      const errText = getErrorText(errcode) || '서버 연결이 원활하지 않습니다. 새로고침해 주세요.'
      const detailTournamentId = this.detailMatchTournamentId ? _.clone(this.detailMatchTournamentId) : undefined
      switch (errcode) {
        case ERR.BET_FAIL_DIFFRENT_RATE:
          globalStore.showBubblePopupTimer(BubbleTextType.DEFAULT_ALERT, errText, BubbleType.BET_SLIP)
          await this.testChangeRate(orgCart, true)
          break
        case ERR.BET_FAIL_LESSER_BETTING_MIN:
        case ERR.BET_FAIL_GREATER_BETTING_MAX: {
          await this.refreshClubOption()
          const club_bet = getClubMinMaxBet(typeOn, betMoneyType, this.clubOption)
          globalStore.showBubblePopupTimer(
            BubbleTextType.DEFAULT_ALERT,
            getMixMaxBetError(errText, club_bet.betmoney_min, club_bet.betmoney_max),
            BubbleType.BET_SLIP,
          )
          break
        }
        case ERR.BET_FAIL_PRE_MATCH_STARTED:
        case ERR.BET_FAIL_INACTIVE_LIVE:
        case ERR.BET_FAIL_ALREADY_OUTCOME:
        case ERR.BET_FAIL_INACTIVE_MARKET: {
          const isLocked = await this.diagnoseFolds({ clubId: params.clubId, betCalls: params.betCalls })

          if (isLocked) {
            showToast(TOAST_TYPE.INFO, '베팅 타입이 잠겼습니다. 베팅슬립을 확인해주세요.')
            this.setBetSlipScrollToTop(true)
          } else {
            showToast(TOAST_TYPE.INFO, errText)
          }

          runInAction(() => {
            if (detailTournamentId) {
              this.setIsKeepMatchDetail(true)
            }
          })

          if (!_.isNil(this.tournamentFilterList)) {
            await this.fetchFilteredTournamentTracks({ limit: 20, reset: true, pageType: PAGE_TYPE.MATCHUP_FILTER })
          } else {
            if (this.gameKey === GAME_TYPE.LIVE) {
              await this.fetchTournamentTracks({ limit: 999, reset: true, pageType: PAGE_TYPE.LIVE })
            } else {
              await this.fetchTournamentTracks({ limit: 20, reset: true, pageType: PAGE_TYPE.MATCHUP })
            }
          }

          if (this.tracks && detailTournamentId) {
            this.fetchMatchupDetailMarkets({
              gameType: this.currentGameKey,
              clubId: this.club.id,
              producerId: this.producerId,
              matchId: this.detailMatchId,
              tournamentId: detailTournamentId,
            }, this.gameKey === GAME_TYPE.LIVE)
          }
          break
        }
        case ERR.BET_FAIL_GREATER_HIT_MAX:
          await this.refreshClubOption()
          this.clubOption.hit_max = this.betMoneyType === PROPERTY_ID.NEW_BET_TICKET_G
            ? this.clubOption.hit_max / RATIO_TICKET : this.clubOption.hit_max
          globalStore.showBubblePopupTimer(
            BubbleTextType.DEFAULT_ALERT,
            `${errText}(${formatNumber(this.clubOption.hit_max)})`,
            BubbleType.BET_SLIP,
          )
          break
        case ERR.BET_FAIL_GREATER_LIMIT_BETTING_RATE:
          await this.refreshClubOption()
          globalStore.showBubblePopupTimer(
            BubbleTextType.DEFAULT_ALERT,
            `${this.clubOption.limit_betting_rate}배 이상 베팅하실 수 없습니다.`,
            BubbleType.BET_SLIP,
          )
          break
        case ERR.BET_FAIL_UNAVAILABLE_CROSS_SINGLE_BET:
        case ERR.BET_FAIL_UNAVAILABLE_WDL_SINGLE_BET:
        case ERR.BET_FAIL_UNAVAILABLE_HANDI_UN_OVER_SINGLE_BET:
          await this.showOneFoldPopupOrErrTextToast(BET_TYPE_ON.UNIFIED_MATCH, errText)
          break
        case ERR.BET_FAIL_UNAVAILABLE_SPECIAL_SINGLE_BET:
          await this.showOneFoldPopupOrErrTextToast(BET_TYPE_ON.UNIFIED_SPECIAL, errText)
          break
        case ERR.BET_FAIL_UNAVAILABLE_LIVE_SINGLE_BET:
          await this.showOneFoldPopupOrErrTextToast(BET_TYPE_ON.UNIFIED_LIVE, errText)
          break
        case ERR.BET_FAIL_POST_RULE_ODDS:
        case ERR.BET_FAIL_SPORT_ODDSTYPE_RULE_NOT_FOUND:
          this.setUseBetSlipRefreshButtonInsteadOfBettingButton(true)
          globalStore.showBubblePopupTimer(BubbleTextType.DEFAULT_ALERT, errText, BubbleType.BET_SLIP)
          break
        case ERR.BET_FAIL_INSUFFICIENT_MONEY: {
          const convertedErrText = getErrorTextByBetMoneyType(errText, betMoneyType)
          globalStore.showBubblePopupTimer(BubbleTextType.DEFAULT_ALERT, convertedErrText, BubbleType.BET_SLIP)
          break
        }
        default:
          globalStore.showBubblePopupTimer(BubbleTextType.DEFAULT_ALERT, errText, BubbleType.BET_SLIP)
          break
      }
      return
    }

    this.successBetPopup()
    this.updateClub(club)
    authStore.updateUserAssets(user)
    componentStore.updateSelectedUserExtraOddsItemAfterBet()

    this.incrementPreMatchBetSuccessCountAfterBetSlipOpened()
    if (!isMobile) {
      showCasinoAdvertisementPopup()
    }

    this.updateSettlementSupport(settlementSupport)
    this.showSettlementSupportPopup(settlementSupport)
    this.mobileAppRecordEventByFirstBet(userConditionState?.isFirstBetByCivalue ?? false)

    if (funcSucceed) {
      funcSucceed()
    }
  }

  @action
  betSpecial = async (
    cart: CartItem[],
    betMoney: number,
    betMoneyType: number,
    regular: boolean,
    funcSucceed?: () => void,
  ) => {
    try {
      if (betMoney === 0) {
        showToast(TOAST_TYPE.INFO, '베팅머니를 입력하세요.')
        return
      }

      if (_.isNil(cart) || cart.length === 0) {
        return
      }

      globalStore.pushDialogOk({ title: '알림', text: ['베팅중입니다...'], className: 'small-size' })
      const splitted = this.descriptor.split(':')
      const [clubId /* gameKey */] = splitted

      // 베팅 룰 사전 검사
      // const ret = canGameTypesFoldCount(gameKey, cart.length, this.rules)
      // if (!ret.allowed) {
      //   globalStore.closeDialog()
      //   globalStore.pushDialogOk({ title: '알림', text: [ret.message] })
      //   return
      // }

      const betCalls: Schema$BinBetCall[] = []

      const [cartItem] = cart
      const { sportId, matchId, selection } = cartItem
      const callType = cart.length > 1 ? BET_CALL_TYPE.MULTI : BET_CALL_TYPE.SINGLE

      const tickets: Schema$BetTicket[] = []

      for (const el of cart) {
        const bc: Schema$BinBetCall = {
          matchId: el.matchId,
          sportId: el.sportId,
          categoryId: 0,
          tournamentId: 0,

          marketId: '',
          marketType: el.marketType,
          specialBetValue: '',
          selection,
          outcomeRate: el.rate.toString(),

          typeOn: BET_TYPE_ON.SPECIAL,
          category: MATCHUP_CATEGORY.SPECIAL,
          callType,
          betMoney,
          tickets,
        }
        betCalls.push(bc)
      }

      const params: IBinBet.Params = {
        clubId,
        gameKey: matchId,
        callType,
        binGameType: sportId,
        betCalls,
      }
      const { errcode, club, user } = await this.api.game.doSpecialBet(params)
      globalStore.closeDialog()
      if (errcode) {
        switch (errcode) {
          case ERR.BET_FAIL_DIFFRENT_RATE:
            await this.testChangeRate(cart, true)
            break
          default:
            globalStore.pushDialogOk({
              title: '알림',
              text: [getErrorText(errcode) || '서버 연결이 원활하지 않습니다. 새로고침해 주세요.'],
              className: 'small-size',
            })
            break
        }
      } else {
        globalStore.pushDialogOk({ title: '알림', text: ['베팅에 성공하였습니다.'], className: 'small-size' })

        this.clearCart()
        this.updateClub(club)
        authStore.updateUserAssets(user)

        if (funcSucceed) {
          funcSucceed()
        }

        this.setCurrentSpecialBet(sportId, cart)
      }
    } catch (err) {
      globalStore.closeDialog()
      console.error(err)
      globalStore.pushDialogOk({ title: '알림', text: ['베팅중 에러가 발생했습니다.'], className: 'small-size' })
    }
  }

  @action
  setCurrentSpecialBet = (sportId: number, cart: CartItem[]) => {
    const newSpecialBet = {
      ...this.currentSpecialBet,
    }
    newSpecialBet[sportId] = _.cloneDeep(cart)
    this.currentSpecialBet = newSpecialBet
  }

  @action
  bet = async () => {
    try {
      const [cartItem] = this.cart
      if (cartItem) {
        if (cartItem.isSpecial === true) {
          await this.betSpecial(this.cart, this.betMoney, this.betMoneyType, true)
        } else {
          await this.betCommon(this.cart, this.betMoney, this.betMoneyType, true)
        }
      }
    } catch (err) {
      console.error(err.message)
    }
  }

  @action
  pushBetResult = async (packet: PushBetResultPacket) => {
    globalStore.setVisibleLiveBetCounter(false)
    if (packet.errObj) {
      const { errcode } = packet.errObj
      await this.liveBetResultError(errcode)
      return
    }

    authStore.updateUserAssets(packet.userInfo)
    componentStore.updateSelectedUserExtraOddsItemAfterBet()
    this.successBetPopup()
  }

  successBetPopup = () => {
    // const cookieKey = makeCookieKeyByUser(COOKIE_KEYS.BETTING_SUCCESS_POPUP_INVISIBLE_FOR_MATCHUP, authStore)
    // const checked = getCookie(cookieKey)
    if (this.isKeepCart) {
      globalStore.showBetCompleteAniTimer()
      // globalStore.showBubblePopupTimer(BubbleTextType.SUCCESS, this.producerId === ProducerType.LIVEODDS ? SUCCESS_LIVE_BET_TEXT : SUCCESS_PRE_BET_TEXT, BubbleType.BET_SLIP)

      if (this.producerId === ProducerType.LIVEODDS) {
        globalStore.showBubblePopupTimer(BubbleTextType.LIVE_SUCCESS, SUCCESS_LIVE_BET_TEXT, BubbleType.BET_SLIP)
      } else {
        globalStore.showBubblePopupTimer(BubbleTextType.SUCCESS, SUCCESS_PRE_BET_TEXT, BubbleType.BET_SLIP)
      }

    } else {
      globalStore.setVisibleBetSuccessPopup(true, COOKIE_KEYS.BETTING_SUCCESS_POPUP_INVISIBLE_FOR_MATCHUP)
      this.clearCart()
    }

    this.realClickEventSuccessBet()
  }

  showOneFoldPopupOrErrTextToast = async (betTypeOn: BET_TYPE_ON, errText: string) => {
    if (authStore.isSpecificClubMember) {
      globalStore.showBubblePopupTimer(BubbleTextType.DEFAULT_ALERT, errText, BubbleType.BET_SLIP)
    } else {
      await clubStore.getSingleBetPossibleClubList(betTypeOn)
      if (betTypeOn === BET_TYPE_ON.UNIFIED_LIVE) {
        globalStore.setVisibleMatchupDetailOneFoldPopup(true)
      } else if (this.cart.length > 0) {
        const category = this.getBetCallCategory(this.category, this.cart[0].marketType)
        if (category === MATCHUP_CATEGORY.CROSS) {
          globalStore.setVisibleOneFoldPopup(true)
        } else {
          globalStore.setVisibleMatchupDetailOneFoldPopup(true)
        }
      }
    }
  }

  @action
  clearCart = (executeToggleCartUpdated = true): CartItem[] => {
    _.forEach(this.cart, cartItem => {
      const { matchId, marketType, sportId } = cartItem
      this.updateFightingOdds(matchId, marketType, true)
      this.updateDisabledOdds(matchId, marketType, sportId)
    })

    this.cart = []
    this.setBetMoney(0, PROPERTY_ID.MONEY)
    this.setUseBetSlipRefreshButtonInsteadOfBettingButton(false)
    componentStore.setSelectedUserExtraOddsItem(null)

    if (executeToggleCartUpdated) {
      this.toggleCartUpdated()
    }

    if (isMobile) {
      this.toggleMinimizeBetSlip(true)
    }

    return this.cart
  }

  @action
  setBetMoney = (betMoney: number, betMoneyType: PROPERTY_ID): number => {
    if (betMoney >= 0 && this.betMoneyType !== betMoneyType) {
      // g머니와 베팅권은 함께 사용할수 없기 때문
      this.betMoney = 0
    }
    this.betMoney = betMoney
    this.betMoneyType = betMoneyType
    return betMoney
  }

  @action
  resetDetailTrack = () => {
    this.detailTrack = undefined
    this.detailMatchTournamentId = undefined
  }

  @action
  joinClub = async (clubId: string, ownerId: string, joinOnly = false): Promise<ClubInfoItem | null> => {
    try {
      const { errcode, club } = await this.api.game.joinClub({ clubId, ownerId })
      if (errcode) {
        const errText = getErrorText(errcode) || `서버 연결이 원활하지 않습니다. 새로고침해 주세요. (${errcode})`
        showToast(TOAST_TYPE.INFO, errText)
        return null
      }
      if (!joinOnly) {
        this.setClub(club)
      }
      return club
    } catch (err) {
      console.error(err)
      return null
    }
  }

  @action
  resetClubInfo() {
    this.setClub({})
    this.setRules({})
    this.setBinInfo({})
    this.setEanbledLiveLicense(true)
  }

  @action
  fetchClubLiveLicense = async (clubId: string) => {
    try {
      let isEnabledLiveLicense = true
      const useLiveLicense = globalStore.findGlobalSetting(GlobalStoreKey.USE_LIVE_LICENSE)

      if (useLiveLicense?.value === '1') {
        const { isEnabled } = await this.api.club.getEnabledClubLiveLicense({ clubId })
        isEnabledLiveLicense = isEnabled
      }

      this.setEanbledLiveLicense(isEnabledLiveLicense)
    } catch (err) {
      console.error(err)
    }
  }

  @action
  fetchMatchupClub = async (params: IMatchupClub.Params): Promise<ClubInfo> => {
    try {
      if (!this.club || this.club.id !== params.clubId) {
        this.api.game.getMatchupClub(params).then(response => {
          const { club, rules, binInfos, liveMatchCount, clubMessage, clubNoticeReadHistories } = response

          if (club.state !== CLUB_STATE.RUNNING) {
            globalStore.pushDialogOk({
              text: ['클럽의 운영이 중지되었습니다.'], className: 'small-size',
              callbackCloseDialog: () => {
                const representativeClubId = globalStore.findGlobalSetting(GlobalStoreKey.REPRESENTATIVE_CLUB)?.value
                this.changeClubId(representativeClubId || process.env.DEFAULT_CLUB_ID)
              },
            })
          }
          if (this.club && this.club.id !== club.id) {
            this.cleanup()
          }
          if (params.clubId && params.clubId !== club.id) {
            this.cleanup()
            this.changeClubId(club.id)
          } else {
            this.setClub(club)
            this.setRules(rules)
            this.setBinInfo(binInfos)
            this.fetchClubLiveLicense(club.id)
            this.setClubNoticeReadHistories(clubNoticeReadHistories)
            userStore.setLiveMatchCount(liveMatchCount)
            componentStore.fetchMatchupBanners(club.id)
            componentStore.updateIsVisibleEtcAlertOptions()
            this.refreshClubOption(getPropertyIdByBetSlipIndexKey(this.selectedBetSlipTabIndexKey))
          }
          messageStore.setupUnReadClubMessage(clubMessage, club.id)
        }).catch(err => {
          console.error(err)
        })
      }
    } catch (err) {
      // routerStore.push('/club')
      console.error(err)
    }

    return this.club
  }

  setDetailMatchId = (matchId: number) => {
    this.detailMatchId = matchId
  }

  @action
  setCategoryTab = (categoryTab: number, gameKey: GAME_TYPE, skipClearCart = false) => {
    this.sportTab = null
    this.currentSportsKey = null
    this.currentSportId = null
    this.majorUniqueID = null

    this.categoryTab = categoryTab
    this.currentGameKey = gameKey
    this.producerId = ProducerType.PREODDS

    // 모바일은 경우에 따라 베팅슬립을 초기화 하지 않는 시나리오가 존재한다.
    if (!skipClearCart) {
      this.clearCart()
    }

    if (!isMobile) {
      this.resetDetailTrack()
    }

    this.clearViewControllers()


    if (this.pageType === PAGE_TYPE.MATCHUP_RESULT) {
      this.setSelectedDetailTabs(this.getDefaultScorePageDetailTabs())
    }
  }

  @action
  setSportTab = (sportTab: number, subKey: string, sportId: number) => {
    this.majorUniqueID = null
    this.sportTab = sportTab
    this.currentSportsKey = subKey
    this.currentSportId = sportId

    if (Number(subKey) > 0) {
      this.currentSportId = Number(subKey)
    } else if (_.toNumber(subKey) !== sportId) {
      this.currentSportId = _.toNumber(subKey)
    }

    runInAction(() => {
      this.tracks = []
      this.filteredTracks = []
      this.matchupFilter = { total: 0, major: {}, minor: {}, majorList: [], minorList: [] }
      this.favoriteMatchCount = undefined
      this.favoriteMatchIds = []
      this.myBetMatchCount = undefined
      this.myBetMatchIds = []
      this.resetTournamentFilterList()
    })
    this.resetDetailTrack()
    this.clearViewControllers()

    if (this.pageType === PAGE_TYPE.MATCHUP_RESULT) {
      this.setSelectedDetailTabs(this.getDefaultScorePageDetailTabs())
    }
  }

  @action
  setSportId = (sportId: number) => {
    if (this.currentSportId === sportId) {
      return
    }
    this.currentSportId = sportId
  }

  @action
  refreshSportTab = () => {
    this.setSportTab(this.sportTab, this.currentSportsKey, this.currentSportId)
  }

  @action
  setMajorUniqueID = (id: number) => {
    if (this.majorUniqueID === id) {
      return
    }

    runInAction(() => {
      this.tracks = []
      this.filteredTracks = []
      this.resetTournamentFilterList()
    })
    this.resetDetailTrack()
    this.majorUniqueID = id
  }

  @action
  setCurrentGameKey = (gameKey: GAME_TYPE) => {
    this.currentGameKey = gameKey
  }

  @action
  updateLiveMarket = (newTracks: Schema$TournamentTrack[]) => {
    // NOTE : 라이브 페이지에서 10초마다 reload를 해주는데
    //        regulars는 현재 가지고있는 값이 없을경우 한번만 갱신하고.
    //        irregulars는 매 시간마다 갱신해준다.
    //        프리매치나 나머지는 동일하게 적용
    this.tracks = _.chain(this.tracks).filter(track => {
      return !_.chain(newTracks).find({
        sportId: track.sportId,
        categoryId: track.categoryId,
        tournamentId: track.tournamentId,
        firstDateOfMatch: track.firstDateOfMatch,
      }).isEmpty().value()
    }).value()

    for (let i = 0; i < _.size(newTracks); i += 1) {
      const newTrack = newTracks[i]
      const track = _.find(this.tracks, {
        sportId: newTrack.sportId,
        categoryId: newTrack.categoryId,
        tournamentId: newTrack.tournamentId,
        firstDateOfMatch: newTrack.firstDateOfMatch,
      })

      if (track) {
        track.matches = _.map(newTrack.matches, newMatch => {
          const match = _.find(track.matches, { matchId: newMatch.matchId })

          if (match) {
            match.isVisible = newMatch.isVisible
            match.matchStatusCode = newMatch.matchStatusCode
            match.matchStatusName = newMatch.matchStatusName
            if (!newMatch.isVisible) {
              match.regulars = []
              match.irregulars = []
              this.clearCart()
            } else if (match.regulars.length === 0 && newMatch.regulars.length > 0) {
              match.regulars = [].concat(newMatch.regulars)
            }

            if (newMatch.isVisible) {
              match.irregulars = [].concat(newMatch.irregulars)
              match.irregularCount = newMatch.irregularCount
            }
            return match
          }

          return newMatch
        })
      } else {
        this.tracks.splice(i, 0, newTrack)
      }
    }
  }

  @action
  fetchTournamentTracks = async (params: SimpleFetchItemsParams): Promise<MatchupTrackData> => {
    const { limit, reset, pageType } = params
    if (pageType !== PAGE_TYPE.MATCHUP_RESULT) {
      if (_.isNil(this.club) || this.club.id === '') {
        return null
      }
    }

    if (_.isNil(this.currentGameKey)) {
      return null
    }

    if (_.isNil(this.currentSportsKey) || this.currentSportsKey === '') {
      return null
    }

    if (this.currentGameKey === GAME_TYPE.LIVE && !this.enabledClubLiveLicense) {
      return null
    }

    if (pageType !== PAGE_TYPE.MATCHUP_RESULT && _.isNil(this.majorUniqueID)) {
      return null
    }

    const gameKey = pageType === PAGE_TYPE.MATCHUP_RESULT ? GAME_TYPE.CROSS : this.currentGameKey
    const subKey = this.currentSportsKey
    let uniqueIdGroup = this.majorUniqueID
    if (subKey === _.toString(EXCEPTIONAL_SPORT_ID_GROUP.ETC) && this.majorUniqueID > 0) {
      uniqueIdGroup = EXCEPTIONAL_UNIQUE_ID.MINOR_LEAGUE
    }

    if (Number(subKey) > 0 && this.currentSportId <= 0) {
      this.currentSportId = Number(subKey)
    }

    const sportId = this.currentSportId

    let doReset = reset
    const clubId = this.club ? this.club.id : null
    const descriptor = doReset ? '' : this.descriptor || ''

    try {
      const splitted = descriptor.split(':')
      const [lastClubId, lastGameKey, lastSubKey, lastUniqueIdGroup] = splitted

      let orderId = this.tracks.length > 0 ? this.lastOrderId : undefined
      if (this.producerId === ProducerType.LIVEODDS && _.toString(pageType) !== PAGE_TYPE.MATCHUP_RESULT) {
        orderId = undefined
      }

      // 예전값이랑 인자가 다르면 majorTournament 를 업데이트 한다.
      // 경기결과는 gameKey 와 subKey 가 이전과 다를 수 있기 때문에 최초 한번 리셋 이후 건너띈다.
      // 예) 라이브 선택 후 경기결과 페이지 이동시 경기결과는 gameKey 가 cross 라이브는 live 라서 달라지는데
      // 이걸 리셋 해버리면 경기결과에서 orderId 가 초기화되어 페이징 처리가 되지 않는다.
      if (
        pageType !== PAGE_TYPE.MATCHUP_RESULT && (
          lastClubId !== String(clubId) ||
          lastGameKey !== gameKey ||
          lastSubKey !== subKey ||
          lastUniqueIdGroup !== uniqueIdGroup.toString()
        )
      ) {
        doReset = true
      }

      const copiedFavoriteMatchIds = toJS(this.favoriteMatchIds)
      const copiedMyBetMatchIds = toJS(this.myBetMatchIds)
      if (doReset === true) {
        runInAction(() => {
          this.totalTournamentTracksCount = 0
          this.isLoading = true
          this.hasMore = true
          this.matches = []
          this.metaSportsDict = {}
          this.metaCategoriesDict = {}
          this.metaTournamentsDict = {}
          this.metaTeamsDict = {}
          this.metaMarketDict = {}
          this.metaOutcomeDict = {}
          this.metaMatchStatusDict = {}
          this.viewControllers = {}
          this.lastOrderId = undefined
          this.recommendMatchCount = undefined
          this.recommendLeagueCount = undefined
          this.etcMatchCount = undefined
          this.etcLeagueCount = undefined
          this.totalMatchCount = undefined
          this.totalLiveMatchCount = undefined
          this.favoriteMatchCount = undefined
          this.processedMatchCount = undefined
          this.closedMatchCount = undefined
          this.favoriteMatchIds = []
          this.myBetMatchCount = undefined
          this.myBetMatchIds = []
          this.progressingMatchCount = undefined
          this.matchupFilterList = undefined
          this.isAlreadyDisplayedUserPrickPromotionBanner = undefined
          this.leagueTabHotMatchCount = undefined
          this.setIsBannerRendered(false)
        })

        orderId = undefined
      } else if (this.isLoading || (this.currentGameKey !== GAME_TYPE.LIVE && !this.hasMore)) {
        this.isLoading = false
        return null
      }

      if (pageType === PAGE_TYPE.MATCHUP_RESULT) {
        const matchStatues = []
        const selectedDetailTabs = this.getActiveScorePageDetailTabs()

        if (selectedDetailTabs.includes(DETAIL_TAB.CLOSED)) {
          matchStatues.push(MATCH_GAME_STATUS.Closed)
          matchStatues.push(MATCH_GAME_STATUS.Ended)
        }

        if (selectedDetailTabs.includes(DETAIL_TAB.PROCESSED)) {
          matchStatues.push(MATCH_GAME_STATUS.Live)
        }

        // console.log('!==== selectedDetailTabs ====! ', this.selectedDetailTabs)
        console.log('!==== matchStatues ====! ', matchStatues)

        const tracksResult = await this.api.result.getTournamentTracks({
          gameType: gameKey,
          sportId,
          sportIdGroup: sportId,
          uniqueIdGroup,
          pageType,
          orderId,
          favoriteMatchIds: copiedFavoriteMatchIds,
          myBetMatchIds: copiedMyBetMatchIds,
          matchStatues,
          limit,
        })

        // this.setMatchTabInitializeSportId(null)
        // this.setMatchTabInitializeMajorUniqueId(null)

        const { error } = tracksResult
        if (!tracksResult || error === DUPLICATE_REQUEST_EXCEPTION) {
          return null
        }

        runInAction(() => {
          let firstPage = false
          if (_.isEmpty(this.tracks)) {
            firstPage = true
          }

          if (doReset) {
            this.tracks = _.concat<TournamentTrack>([], tracksResult.tracks)
          } else {
            this.tracks = _.concat<TournamentTrack>(this.tracks, tracksResult.tracks)
          }

          if (firstPage) {
            this.matchupBlockBannerVisibleIndex = this.tracks.length
          }
          this.isLoading = false

          if (tracksResult.totalMatchCount < 1 && !isMajorSportsType(_.toString(sportId))) {
            runInAction(() => {
              this.setSportTab(0, SPORTS_TYPE.HOT, _.toNumber(SPORTS_TYPE.HOT))
              componentStore.setIsGoToFirstScrollOfSportTab(true)
              return
            })
          }

          // 카트 초기화를 방지 하기 위해 descriptor 를 기존값으로 유지 한다.
          // this.descriptor = `${clubId}:${gameKey}:${subKey}:${uniqueIdGroup}`
          if (tracksResult.lastOrderId) {
            this.lastOrderId = _.toString(tracksResult.lastOrderId)
          }

          this.hasMore = tracksResult.hasMore

          if (_.isNil(this.totalMatchCount)) {
            this.totalMatchCount = tracksResult.totalMatchCount
          }

          if (_.isNil(this.recommendMatchCount)) {
            this.recommendMatchCount = tracksResult.majorMatchCount
          }

          if (_.isNil(this.recommendMatchCount)) {
            this.recommendMatchCount = tracksResult.majorMatchCount
          }

          if (_.isNil(this.leagueTabHotMatchCount)) {
            this.leagueTabHotMatchCount = tracksResult.hotMatchCount
          }

          this.sportTabSports = _.cloneDeep(tracksResult?.metaSports ?? [])
          this.favoriteMatchCount = tracksResult.favoriteMatchCount
          this.favoriteMatchIds = tracksResult.favoriteMatchIds
          this.myBetMatchCount = tracksResult.myBetMatchCount
          this.myBetMatchIds = tracksResult.myBetMatchIds
          this.matchupFilterList = tracksResult.matchupFilterList
          this.hotMatchCount = tracksResult.hotMatchCount
          this.processedMatchCount = tracksResult.processedMatchCount
          this.closedMatchCount = tracksResult.closedMatchCount
          // this.setIsBannerRendered(false)
          this.makeTournamentTrackMatchInfos(pageType) // 띠배너 위치를 계산하기 위한 맵생성
        })
        this.startScoreRefreshPolling()
      } else {
        // 카트를 유지 할지 여부 clubId 와 가 달라질 때 마다 카트를 초기화 시킨다.
        const keepCart = this.descriptor.indexOf(`${clubId}`) >= 0
        if (!keepCart) {
          this.clearCart()
        }

        this.isTournamentTrackLoading = true
        const result = await this.api.game.getGameTournamentTracks({
          clubId,
          sportIdGroup: Number(subKey),
          sportId,
          // uniqueId,
          uniqueIdGroup,
          orderId,
          limit,
          gameType: gameKey,
          pageType,
          favoriteMatchIds: copiedFavoriteMatchIds,
          myBetMatchIds: copiedMyBetMatchIds,
          onlyIrregularCount: true,
          ignoreMatchupFilterList: false,
          isNeedToFavoriteMatchIdsWhenFetchTournamentTracks: this.isNeedToFavoriteMatchIdsWhenFetchTournamentTracks,
          isAlreadyDisplayedUserPrickPromotionBanner: this.isAlreadyDisplayedUserPrickPromotionBanner,
        })

        this.setMatchTabInitializeSportId(null)
        this.setMatchTabInitializeMajorUniqueId(null)
        this.setIsNeedToFavoriteMatchIdsWhenFetchTournamentTracks(false)

        const { error, feedSupplier, marketProviderData } = result
        if (error === DUPLICATE_REQUEST_EXCEPTION || !result || gameKey !== this.currentGameKey) {
          return null
        }

        if (_.isNil(this.feedSupplier) || this.feedSupplier !== feedSupplier) {
          this.feedSupplier = feedSupplier
        }
        if (_.isNil(this.getMarketProvider()) || !_.isEqual(this.marketProviderData, marketProviderData)) {
          this.setMarketProviderData(marketProviderData)
        }

        if (!this.totalTournamentTracksCount) {
          this.totalTournamentTracksCount = result.totalMatchCount
        }
        if (result.lastOrderId) {
          this.lastOrderId = _.toString(result.lastOrderId)
        }
        this.producerId = gameKey === 'live' ? ProducerType.LIVEODDS : ProducerType.PREODDS
        this.descriptor = `${clubId}:${gameKey}:${subKey}:${uniqueIdGroup}`

        if (result?.isAlreadyDisplayedUserPrickPromotionBanner) {
          this.isAlreadyDisplayedUserPrickPromotionBanner = result.isAlreadyDisplayedUserPrickPromotionBanner
        }

        runInAction(() => {
          let firstPage = false
          if (_.isEmpty(this.tracks)) {
            firstPage = true
          }

          if (gameKey === GAME_TYPE.LIVE) {
            if (doReset) {
              this.tracks = _.isEmpty(result.tracks) ? [] : _.concat<TournamentTrack>([], result.tracks)
            } else if (!_.isEmpty(result.tracks)) {
              this.updateLiveMarket(result.tracks)
            }
          } else {
            this.tracks = _.concat<TournamentTrack>(doReset ? [] : this.tracks, result.tracks)

            // 스포츠 탭에서 전체, 메이저 종목 외 종목에서 경기가 없는 경우 스포츠 탭 - 전체 - 주요 탭으로 이동
            // 이동 시 스포츠 탭 가로 스크롤 초기화
            if (this.gameKey !== GAME_TYPE.LIVE && result.totalMatchCount < 1) {
              if (!isMajorSportsType(_.toString(sportId))) {
                runInAction(() => {
                  this.setSportTab(0, SPORTS_TYPE.HOT, _.toNumber(SPORTS_TYPE.HOT))
                  componentStore.setIsGoToFirstScrollOfSportTab(true)
                  return
                })
              }
            }
          }

          if (firstPage) {
            this.matchupBlockBannerVisibleIndex = this.tracks.length
          }

          this.matchupFilter = {
            total: result.totalMatchCount,
            major: result?.major ?? {},
            minor: result?.minor ?? {},
            majorList: result?.majorList ?? [],
            minorList: result?.minorList ?? [],
          }

          this.sportTabSports = _.cloneDeep(result?.metaSports ?? [])
          this.hasMore = result.hasMore

          this.isLoading = false
          if (_.isNil(this.recommendMatchCount)) {
            this.recommendMatchCount = result.majorMatchCount
          }
          if (_.isNil(this.recommendLeagueCount) && !_.isEmpty(this.matchupFilter.majorList)) {
            if (Number(subKey) > 0) {
              this.recommendLeagueCount = _.chain(this.matchupFilter.majorList)
                .filter({ SportID: Number(subKey) }).size().value()
            } else {
              this.recommendLeagueCount = _.size(this.matchupFilter.majorList)
            }
          }
          if (_.isNil(this.etcMatchCount) && !_.isEmpty(this.matchupFilter.minorList)) {
            if (Number(subKey) > 0) {
              this.etcMatchCount = _.chain(this.matchupFilter.minorList).filter({ SportID: Number(subKey) }).map('matchCount').sum().value()
            } else {
              this.etcMatchCount = _.chain(this.matchupFilter.minorList).map('matchCount').sum().value()
            }
          }
          if (_.isNil(this.etcLeagueCount) && !_.isEmpty(this.matchupFilter.minorList)) {
            if (Number(subKey) > 0) {
              this.etcLeagueCount = _.chain(this.matchupFilter.minorList)
                .filter({ SportID: Number(subKey) }).size().value()
            } else {
              this.etcLeagueCount = _.size(this.matchupFilter.minorList)
            }
          }
          if (_.isNil(this.totalLiveMatchCount)) {
            this.totalLiveMatchCount = result.totalMatchCount
          }
          if (_.isNil(this.totalMatchCount)) {
            // let totalMatchCount = 0
            // if (this.etcMatchCount) {
            //   totalMatchCount += this.etcMatchCount
            // }
            // if (this.recommendMatchCount) {
            //   totalMatchCount += this.recommendMatchCount
            // }
            // this.totalMatchCount = totalMatchCount
            this.totalMatchCount = result.totalMatchCount
          }
          this.hotMatchCount = result.hotMatchCount
          if (_.isNil(this.matchupFilterList)) {
            this.matchupFilterList = result.matchupFilterList
          }

          if (_.isNil(this.leagueTabHotMatchCount)) {
            this.leagueTabHotMatchCount = result.hotMatchCount
          }

          this.favoriteMatchCount = result.favoriteMatchCount
          this.favoriteMatchIds = result.favoriteMatchIds
          this.myBetMatchIds = result.myBetMatchIds
          this.myBetMatchCount = result.myBetMatchCount
          this.progressingMatchCount = result.progressingMatchCount
          this.isTournamentTrackLoading = false
          // this.setIsBannerRendered(false)
          this.makeTournamentTrackMatchInfos(pageType)// 띠배너 위치를 계산하기 위한 맵생성
        })

        return {
          tracks: this.tracks,
          isLoading: this.isLoading,
          hasMore: this.hasMore,
        }
      }
    } catch (err) {
      runInAction(() => {
        this.isTournamentTrackLoading = false
        this.totalTournamentTracksCount = 0
        this.tracks = []
        this.isLoading = false
        this.hasMore = false
        this.metaSportsDict = {}
        this.metaCategoriesDict = {}
        this.metaTournamentsDict = {}
        this.metaTeamsDict = {}
        this.metaMarketDict = {}
        this.metaOutcomeDict = {}
        this.metaMatchStatusDict = {}
        this.emblemPrefix = ''
        this.matches = []
        this.matchupFilter = { total: 0, major: {}, minor: {}, majorList: [], minorList: [] }
        this.lastOrderId = undefined
        this.matchupBlockBannerVisibleIndex = undefined
        this.recommendMatchCount = undefined
        this.recommendLeagueCount = undefined
        this.etcMatchCount = undefined
        this.etcLeagueCount = undefined
        this.totalMatchCount = undefined
        this.totalLiveMatchCount = undefined
        this.favoriteMatchCount = undefined
        this.favoriteMatchIds = []
        this.myBetMatchIds = []
        this.myBetMatchCount = undefined
        this.progressingMatchCount = undefined
        this.matchupFilterList = []
        this.leagueTabHotMatchCount = undefined
      })
      console.error(err)
      message.error('매치업 페이지를 정상적으로 불러오지 못하였습니다.')
    }
    return null
  }

  @action
  setClub = (club: ClubInfo): ClubInfo => {
    // saveValueToStorage(STORAGE_KEY.LAST_CLUB_ID, club.id)
    this.club = club
    return club
  }

  @action
  updateClub = (update: ClubInfo): ClubInfo => {
    if (this.club.id !== update.id) {
      return null
    }
    const club = _.clone(this.club)
    club.soluble = update.soluble || club.soluble
    this.club = club
    return club
  }

  @action
  setRules = (rules: ClubRules): ClubRules => {
    this.rules = rules
    return rules
  }

  @action
  setBinInfo = (binInfos: ClubBinInfos): ClubBinInfos => {
    this.binInfos = binInfos
    return binInfos
  }

  @action
  setEanbledLiveLicense = (isEnabled: boolean): boolean => {
    this.enabledClubLiveLicense = isEnabled
    return isEnabled
  }

  // @action
  // filterTracks = (
  //   clubId: string,
  //   matches: MatchupItem[],
  //   gameKey: string,
  //   subKey: string,
  //   uniqueId: number,
  //   limit: number,
  // ) => {
  //   const filteredMatches = filterPrematch(matches, subKey)

  //   return this.updateTracks(clubId, filteredMatches, gameKey, subKey, uniqueId, limit)
  // }

  @action
  addDetailCartItem = (
    tournamentId: number,
    matchId: number,
    value: string,
    executeToggleCartUpdated = true,
  ): CartItem[] => {
    const elems = value.split('//')
    const [marketType, specifiers, outcome_type, rate, outcomeMetaId] = elems
    const match = this.detailTrack.track

    if (!match) {
      return null
    }

    let market: Schema$MarketTrack
    const filteredMarkets = match.irregulars.filter(irregulars => irregulars.type === marketType)

    // 동일한 마켓타입 항목이 많은 경우, playingPeriodInfo 을 기준으로 대상 마켓을 찾아야 한다.
    if (_.size(filteredMarkets) > 1) {
      const specifiersObject = JSON.parse(specifiers)
      const playingPeriodInfos = []
      for (const key of Object.keys(specifiersObject)) {
        if (_.includes(PlayingPeriodSpecifierKey, key)) {
          playingPeriodInfos.push({ key, value: specifiersObject[key] })
        }
      }

      market = filteredMarkets.find(filteredMarket => {
        return _.isEqual(filteredMarket.playingPeriodInfos, playingPeriodInfos)
      })
    } else {
      market = match.irregulars.find(irregulars => irregulars.type === marketType)
    }

    let marketName = market ? market.name : 'Unknown'
    marketName = replaceMarketName(marketName, match.homeTeamName, match.awayTeamName)


    let selectedOutcome
    const specifiersObject = JSON.parse(specifiers)
    const selectedSpecKeys = _.keys(specifiersObject)
    for (const tempMarket of market.markets) {
      if (_.size(market.markets) === 1) {
        selectedOutcome = tempMarket.outcomes.find(outcome => outcome.type === outcome_type)
        if (selectedOutcome) {
          break
        }
      }

      // 선택한기준점(specifiers)과 같은 specifiers 를 가진 market 을 대상으로 선택한 아웃컴을 찾아야 한다.
      const tempMarketSpecKeys = _.keys(tempMarket.specifiers)
      if (_.size(tempMarketSpecKeys) !== _.size(_.keys(selectedSpecKeys))) {
        continue
      }

      let isEqualsSpecifiers = true
      for (const tempMarketSpecKey of tempMarketSpecKeys) {
        if (tempMarket.specifiers[tempMarketSpecKey] !== specifiersObject[tempMarketSpecKey]) {
          isEqualsSpecifiers = false
        }
      }
      if (!isEqualsSpecifiers) {
        continue
      }

      selectedOutcome = tempMarket.outcomes.find(outcome => outcome.type === outcome_type)
      if (selectedOutcome) {
        break
      }
    }

    const existingItem = _.find(this.cart, { matchId, marketType, selection: outcome_type })
    const cartItem: CartItem = {
      cartId: existingItem ? existingItem.cartId : uuid.v4(),
      match,
      specifiers: JSON.parse(specifiers),
      selection: outcome_type,
      outcomeMetaId: this.feedSupplier === FEED_SUPPLIER.LSPORTS ? outcomeMetaId : outcome_type,
      rate: Number(rate),
      sportId: this.detailTrack.sportId,
      categoryId: this.detailTrack.categoryId,
      tournamentId,
      matchId,
      marketId: '',
      marketType,
      marketName,
      value,
      checked: false,
      selectedOutcome,
      gameKey: this.currentGameKey,
      producerId: this.producerId,
    }

    const crossCheck = this.crossRuleCheck(matchId, this.detailTrack.sportId, cartItem.marketType, cartItem.selection)
    if (!crossCheck) {
      message.warn('동일경기 불가능한 조합입니다.')
      return null
    }

    this.toggleBetSlipBottomCollapsed(false)

    const filters = _.filter(this.cart, (item) => item.matchId !== matchId)
    this.cart = _.orderBy(filters.concat([cartItem]), 'producerId', 'desc')

    if (executeToggleCartUpdated) {
      this.toggleCartUpdated()
    }

    componentStore.updateSelectedUserExtraOddsItemAfterAddCart()
    return [cartItem]
  }

  @action
  addSpecialCartItem = (value: string): CartItem => {
    const elems = value.split('//')
    const [sportId, matchId, marketType, type, specifiers, rate] = elems

    const filtered = _.reject(this.cart, {
      sportId: Number(sportId),
      matchId: Number(matchId),
      marketType,
    }) as CartItem[]
    const cartItem: CartItem = {
      cartId: uuid.v4(),
      sportId: Number(sportId),
      matchId: Number(matchId),
      marketType,
      selection: type,
      outcomeMetaId: type,
      specifiers: JSON.parse(specifiers),
      rate: Number(rate),
      value,
      isSpecial: true,
      gameKey: this.currentGameKey,
      producerId: this.producerId,
    }
    const newCart = filtered.concat([cartItem])
    this.toggleBetSlipBottomCollapsed(newCart.length === 0)
    this.setBetMoney(this.betMoney, this.betMoneyType)
    this.cart = newCart
    return cartItem
  }

  @action
  removeSpecialCartItem = (value: string, fromSlip = false): CartItem[] => {
    const filtered = _.reject(this.cart, { value }) as CartItem[]

    if (fromSlip === true) {
      this.toggleBetSlipSiderCollapsed(filtered.length === 0)
    }

    this.toggleBetSlipBottomCollapsed(filtered.length === 0)
    this.cart = filtered

    return filtered
  }

  crossRuleCheck = (matchId: number, sportId: number, marketType: string, selected_outcome_type: string): boolean => {
    const splitted = this.descriptor.split(':')
    const [, gameKey] = splitted
    if (gameKey === 'cross' && this.cart.length > 0) {
      const combinationMatchItems: CartItem[] = _.filter(this.cart, item => item.matchId === matchId && !item.isLocked)
      if (combinationMatchItems.length > 0) {
        const combinationSource: CombitionSource[] = []
        for (const el of combinationMatchItems) {
          combinationSource.push({
            marketType: el.marketType,
            outcome: el.outcomeMetaId || el.selection,
          })
        }
        const rules = getSportCombinations(this.rules, gameKey, sportId)
        const allowed = canSportCombinations(rules, combinationSource, {
          marketType,
          outcome: selected_outcome_type,
        })
        if (!allowed) {
          return false
        }
      }
    }

    return true
  }

  @action
  addCartItem = (tournamentId: number, matchId: number, value: string, executeToggleCartUpdated = true): CartItem => {
    const elems = value.split('//')
    const [marketType, specifiers, type, rate, outcomeMetaId] = elems

    let currentTracks
    if (_.isNil(this.tournamentFilterList)) {
      currentTracks = this.tracks
    } else {
      currentTracks = this.filteredTracks
    }

    const tours = _.filter(currentTracks, { tournamentId }) as TournamentTrack[]
    for (const tour of tours) {
      // const lastCartLength = this.cart.length
      const last = _.find(this.cart, { matchId, marketType, selection: type })
      const match = _.find(tour.matches, { matchId }) as MatchTrack

      if (match) {
        let market
        // 동일한 마켓타입 항목이 많은 경우, playingPeriodInfo 을 기준으로 대상 마켓을 찾아야 한다.
        const filteredMarkets = match.regulars.filter(regulars => regulars.type === marketType)
        if (_.size(filteredMarkets) > 1) {
          const specifiersObject = JSON.parse(specifiers)
          const playingPeriodInfos = []
          for (const key of Object.keys(specifiersObject)) {
            if (_.includes(PlayingPeriodSpecifierKey, key)) {
              playingPeriodInfos.push({ key, value: specifiersObject[key] })
            }
          }

          market = filteredMarkets.find(filteredMarket => {
            return _.isEqual(filteredMarket.playingPeriodInfos, playingPeriodInfos)
          })
        } else {
          market = match.regulars.find(irregulars => irregulars.type === marketType)
        }

        let marketName = market ? market.name : 'Unknown'
        marketName = replaceMarketName(marketName, match.homeTeamName, match.awayTeamName)
        let selectedOutcome
        const specifiersObject = JSON.parse(specifiers)
        const selectedSpecKeys = _.keys(specifiersObject)
        for (const tempMarket of market.markets) {
          if (_.size(market.markets) === 1) {
            selectedOutcome = tempMarket.outcomes.find(outcome => outcome.type === type)
            if (selectedOutcome) {
              break
            }
          }

          // 선택한기준점(specifiers)과 같은 specifiers 를 가진 market 을 대상으로 선택한 아웃컴을 찾아야 한다.
          const tempMarketSpecKeys = _.keys(tempMarket.specifiers)
          if (_.size(tempMarketSpecKeys) !== _.size(_.keys(selectedSpecKeys))) {
            continue
          }

          let isEqualsSpecifiers = true
          for (const tempMarketSpecKey of tempMarketSpecKeys) {
            if (tempMarket.specifiers[tempMarketSpecKey] !== specifiersObject[tempMarketSpecKey]) {
              isEqualsSpecifiers = false
            }
          }
          if (!isEqualsSpecifiers) {
            continue
          }

          selectedOutcome = tempMarket.outcomes.find(outcome => outcome.type === type)
          if (selectedOutcome) {
            break
          }
        }

        const cartItem: CartItem = {
          cartId: last ? last.cartId : uuid.v4(),
          sportId: tour.sportId,
          categoryId: tour.categoryId,
          tournamentId,
          match,
          specifiers: JSON.parse(specifiers) || {},
          selection: type,
          outcomeMetaId: this.feedSupplier === FEED_SUPPLIER.LSPORTS ? outcomeMetaId : type,
          rate: Number(rate),
          marketId: '',
          marketType,
          marketName,
          matchId,
          value,
          checked: false,
          selectedOutcome,
          changeRate: last && last.changeRate ? _.clone(last.changeRate) : undefined,
          gameKey: this.currentGameKey,
          producerId: this.producerId,
        }

        const crossCheck = this.crossRuleCheck(
          matchId, tour.sportId,
          cartItem.marketType,
          cartItem.outcomeMetaId || cartItem.selection,
        )
        if (!crossCheck) {
          message.warn('동일경기 불가능한 조합입니다.')
          return null
        }

        let filtered = _.reject(this.cart, { matchId, marketType }) as CartItem[]
        if (this.producerId === ProducerType.LIVEODDS) {
          filtered = _.reject(filtered, { matchId })
        }
        const newCart = filtered.concat([cartItem])
        this.toggleBetSlipBottomCollapsed(newCart.length === 0)
        this.cart = _.orderBy(newCart, 'producerId', 'desc')
        if (executeToggleCartUpdated) {
          this.toggleCartUpdated()
        }

        if (_.size(this.cart) === 1) {
          componentStore.updateSelectedUserExtraOddsItemAfterAddCart()
        }
        return cartItem
      }
    }
    return null
  }

  changeDisabledOdds(
    ruleType: string,
    vcMatchType: ViewController,
    selection: string,
    rule: CombinationRuleExt,
    outcome: string[],
    reverse: boolean,
    matchId: number,
    marketType: string,
  ) {
    let displayedHome = true
    let displayedDraw = true
    let displayedAway = true

    let irregulars
    if (matchId === this.detailMatchId) {
      irregulars = this.detailTrack?.track?.irregulars.find((track: Schema$MarketTrack) => {
        return track.type === marketType
      })
    }

    if (vcMatchType && selection) {
      const [, , , , outcomeType] = selection.split('//')
      let hKey = ''
      let dKey = ''
      let aKey = ''
      if (outcome.length > 2) {
        if (vcMatchType.isTwoWay) {
          if (isLsportsEnv()) {
            hKey = reverse ? `${outcome[0]}-${outcomeType}` : `${outcomeType}-${outcome[0]}`
            aKey = reverse ? `${outcome[2]}-${outcomeType}` : `${outcomeType}-${outcome[2]}`
          } else {
            hKey = reverse ? `${outcome[3]}-${outcomeType}` : `${outcomeType}-${outcome[3]}`
            aKey = reverse ? `${outcome[4]}-${outcomeType}` : `${outcomeType}-${outcome[4]}`
          }
        } else {
          hKey = reverse ? `${outcome[0]}-${outcomeType}` : `${outcomeType}-${outcome[0]}`
          dKey = reverse ? `${outcome[1]}-${outcomeType}` : `${outcomeType}-${outcome[1]}`
          aKey = reverse ? `${outcome[2]}-${outcomeType}` : `${outcomeType}-${outcome[2]}`
        }
      } else {
        hKey = reverse ? `${outcome[0]}-${outcomeType}` : `${outcomeType}-${outcome[0]}`
        aKey = reverse ? `${outcome[1]}-${outcomeType}` : `${outcomeType}-${outcome[1]}`
      }
      displayedHome = rule[ruleType][hKey]
      displayedDraw = rule[ruleType][dKey]
      displayedAway = rule[ruleType][aKey]
      vcMatchType.setEnabledHome(displayedHome)
      vcMatchType.setEnabledDraw(displayedDraw)
      vcMatchType.setEnabledAway(displayedAway)

      vcMatchType.setEnabledHomeFromViewController(displayedHome)
      vcMatchType.setEnabledAwayFromViewController(displayedAway)

      if (!_.isEmpty(irregulars)) {
        runInAction(() => {
          _.forEach(irregulars?.markets, ((market: Schema$MarketBlock) => {
            const outcomes = market.outcomes
            if (_.size(outcomes) === 2) {
              outcomes[0].isActiveDueToCombinationRule = displayedHome
              outcomes[1].isActiveDueToCombinationRule = displayedAway
            } else {
              outcomes[0].isActiveDueToCombinationRule = displayedHome
              outcomes[1].isActiveDueToCombinationRule = displayedDraw
              outcomes[2].isActiveDueToCombinationRule = displayedAway
            }
          }))
        })
      }
    } else if (vcMatchType && !selection) {
      vcMatchType.setEnabledHome(true)
      vcMatchType.setEnabledDraw(true)
      vcMatchType.setEnabledAway(true)

      vcMatchType.setEnabledHomeFromViewController(true)
      vcMatchType.setEnabledAwayFromViewController(true)

      if (!_.isEmpty(irregulars)) {
        runInAction(() => {
            _.forEach(irregulars?.markets, ((market: Schema$MarketBlock) => {
                const outcomes = market.outcomes
                outcomes.forEach(outcome => {
                  outcome.isActiveDueToCombinationRule = true
                })
              }),
            )
          },
        )
      }
    }
  }

  // 크로스 클럽룰 설정 (기본룰을 제외한 오즈메이커가 설정한 크로스 베팅설정에 따른 disabled)
  updateDisabledOdds(matchId, marketType, sportId, selection?) {
    const cartItem = _.find(this.cart, { matchId, marketType })
    const effectiveSelection = cartItem?.isLocked ? undefined : selection

    const vcMatch = this.viewControllers[matchId]
    if (this.gameKey === GAME_TYPE.CROSS) {
      const rules = getSportCombinations(this.rules, this.gameKey, sportId)
      if (vcMatch) {
        if (this.feedSupplier === FEED_SUPPLIER.LSPORTS) {
          // 승무패
          if (LS_REGULAR_ODDS_WAY.indexOf(marketType) >= 0) {
            for (const el of LS_REGULAR_ODDS_UNDEROVER) {
              this.changeDisabledOdds('way-uo', vcMatch[el], effectiveSelection, rules, LS_OUTCOMES_UNDEROVER, false, matchId, el)
            }
            // 핸디캡
          } else if (LS_REGULAR_ODDS_HANDICAP.indexOf(marketType) >= 0) {
            for (const el of LS_REGULAR_ODDS_UNDEROVER) {
              this.changeDisabledOdds('handi-uo', vcMatch[el], effectiveSelection, rules, LS_OUTCOMES_UNDEROVER, false, matchId, el)
            }
            // 언더오버
          } else if (LS_REGULAR_ODDS_UNDEROVER.indexOf(marketType) >= 0) {
            for (const el of LS_REGULAR_ODDS_WAY) {
              this.changeDisabledOdds('way-uo', vcMatch[el], effectiveSelection, rules, LS_OUTCOMES_WAY, true, matchId, el)
            }
            for (const el of LS_REGULAR_ODDS_HANDICAP) {
              this.changeDisabledOdds('handi-uo', vcMatch[el], effectiveSelection, rules, LS_OUTCOMES_HANDICAP, true, matchId, el)
            }
          }
        } else {
          // 승무패
          // eslint-disable-next-line
          if (UNIFIED_REGULAR_ODDS_WAY.indexOf(marketType) >= 0) {
            for (const el of UNIFIED_REGULAR_ODDS_UNDEROVER) {
              this.changeDisabledOdds('way-uo', vcMatch[el], effectiveSelection, rules, UNIFIED_OUTCOMES_UNDEROVER, false, matchId, el)
            }
            // 핸디캡
          } else if (UNIFIED_REGULAR_ODDS_HANDICAP.indexOf(marketType) >= 0) {
            for (const el of UNIFIED_REGULAR_ODDS_UNDEROVER) {
              this.changeDisabledOdds('handi-uo', vcMatch[el], effectiveSelection, rules, UNIFIED_OUTCOMES_UNDEROVER, false, matchId, el)
            }
            // 언더오버
          } else if (UNIFIED_REGULAR_ODDS_UNDEROVER.indexOf(marketType) >= 0) {   // 언더 오버가 선택되었으면 ..
            for (const el of UNIFIED_REGULAR_ODDS_WAY) {
              this.changeDisabledOdds('way-uo', vcMatch[el], effectiveSelection, rules, UNIFIED_OUTCOMES_WAY, true, matchId, el)
            }
            for (const el of UNIFIED_REGULAR_ODDS_HANDICAP) {
              this.changeDisabledOdds('handi-uo', vcMatch[el], effectiveSelection, rules, UNIFIED_OUTCOMES_HANDICAP, true, matchId, el)
            }
          }
        }
      }
    }
  }


  // 크로스 기본룰 설정 (승무패 선택 시 핸디캡 disabled, 핸디캡 선택시 승무패 disabled)
  updateFightingOdds = (matchId: number, marketType: string, enabled: boolean) => {
    const cartItem = _.find(this.cart, { matchId, marketType })
    const effectiveEnabled = cartItem?.isLocked && !enabled ? true : enabled

    const vcMatch = this.viewControllers[matchId]
    if (vcMatch) {
      let againstOddsList = []
      if (this.feedSupplier === FEED_SUPPLIER.LSPORTS) {
        if (LS_REGULAR_ODDS_WAY.indexOf(marketType) >= 0) {
          againstOddsList = LS_REGULAR_ODDS_HANDICAP
        } else if (LS_REGULAR_ODDS_HANDICAP.indexOf(marketType) >= 0) {
          againstOddsList = LS_REGULAR_ODDS_WAY
        } else if (this.gameKey === GAME_TYPE.SPECIAL) {
          const rules = getSportCombinations(this.rules, this.gameKey, 0)
          if (_.isNil(rules?.special) || rules.special === false) {
            for (const key of Object.keys(vcMatch)) {
              if (key !== marketType) {
                againstOddsList.push(key)
              }
            }
          }
        }
      } else {
        // eslint-disable-next-line
        if (UNIFIED_REGULAR_ODDS_WAY.indexOf(marketType) >= 0) {
          againstOddsList = UNIFIED_REGULAR_ODDS_HANDICAP
        } else if (UNIFIED_REGULAR_ODDS_HANDICAP.indexOf(marketType) >= 0) {
          againstOddsList = UNIFIED_REGULAR_ODDS_WAY
        } else if (this.gameKey === GAME_TYPE.SPECIAL) {
          const rules = getSportCombinations(this.rules, this.gameKey, 0)
          if (_.isNil(rules?.special) || rules.special === false) {
            for (const key of Object.keys(vcMatch)) {
              if (key !== marketType) {
                againstOddsList.push(key)
              }
            }
          }
        }
      }

      for (const el of againstOddsList) {
        const vcOdds = vcMatch[el]
        if (vcOdds) {
          vcOdds.setEnabled(effectiveEnabled)
          if (matchId === this.detailMatchId) {
            runInAction(() => {
              this.detailTrack?.track?.irregulars.forEach((track: Schema$MarketTrack) => {
                if (track.type === el) {
                  track.markets.forEach((market: Schema$MarketBlock) => {
                    market.isActiveDueToCombinationRule = effectiveEnabled
                  })
                }
              })
            })
          }
        }
      }
    }
  }

  @action
  removeCartItem = (
    tournamentId: number,
    matchId: number,
    value: string,
    fromSlip = false,
    executeToggleCartUpdated = true,
  ): CartItem[] => {
    const elems = value.split('//')
    const [marketType] = elems
    const findCart = _.find(this.cart, { matchId, marketType }) as CartItem
    const filtered = _.reject(this.cart, { matchId, marketType }) as CartItem[]

    if (fromSlip === true) {
      this.toggleBetSlipSiderCollapsed(filtered.length === 0)
    }

    this.toggleBetSlipBottomCollapsed(filtered.length === 0)
    this.cart = filtered
    if (filtered.length === 0) {
      this.clearCart(false)
    }

    this.updateFightingOdds(matchId, marketType, true)
    if (findCart) {
      this.clearFieldOddsInViewControllerByCartItem(findCart)
      this.updateDisabledOdds(matchId, marketType, findCart.sportId)
    }

    if (_.isEmpty(this.cart)) {
      componentStore.setSelectedUserExtraOddsItem(null)
    }

    if (executeToggleCartUpdated) {
      this.toggleCartUpdated()
    }

    return filtered
  }

  @action
  toggleCartItem = (cartId: string): CartItem[] => {
    const newCart: CartItem[] = []
    const targetCart = this.cart
    for (const el of targetCart) {
      if (el.cartId === cartId) {
        el.checked = !el.checked
        newCart.push(el)
      } else {
        newCart.push(el)
      }
    }

    if (_.size(this.cart) > 0) {
      this.cart = newCart
    }

    return newCart
  }

  @action
  toggleCartItemAll = (checked: boolean): CartItem[] => {
    const newCart: CartItem[] = []
    const targetCart = this.cart
    for (const el of targetCart) {
      const cloned = _.cloneDeep(el)
      cloned.checked = checked
      newCart.push(cloned)
    }

    if (_.size(this.cart) > 0) {
      this.cart = newCart
    }

    return newCart
  }

  @action
  getCheckedCartItems = () => {
    const targetCart = this.cart
    return _.filter(targetCart, { checked: true })
  }

  @action
  deleteCheckedCartItems = (): CartItem[] => {
    const targetCart = this.cart
    const newCart = _.reject(targetCart, { checked: true })
    const delItems = _.filter(targetCart, { checked: true })
    for (const el of delItems) {
      const vcMatch = this.viewControllers[el.matchId]
      if (vcMatch) {
        const vcOdds = vcMatch[el.marketType]
        if (vcOdds) {
          vcOdds.clearField()
          this.updateFightingOdds(el.matchId, el.marketType, true)
          this.updateDisabledOdds(el.matchId, el.marketType, el.sportId)
        }
      }
    }
    if (newCart.length === 0) {
      if (_.size(this.cart) > 0) {
        this.clearCart(false)
      }
    } else if (newCart.length > 0) {
      if (_.size(this.cart) > 0) {
        this.cart = newCart
      }
    }
    this.toggleCartUpdated()
    return newCart
  }

  @action
  setChargeMoney = (chargeMoney: number): number => {
    this.chargeMoney = chargeMoney
    return chargeMoney
  }

  @action
  toggleBetSlipBottomCollapsed = (collapsed: boolean) => {
    this.collapsedBetSlipBottom = collapsed
    if (collapsed) {
      this.minimizeBetSlip = true
    }
    return collapsed
  }

  @action
  toggleBetSlipSiderCollapsed = (collapsed: boolean) => {
    this.collapsedBetSlipSider = collapsed
    if (collapsed) {
      this.minimizeBetSlip = true
    }
    return collapsed
  }

  @action
  toggleMinimizeBetSlip = (minimize: boolean) => {
    if (this.minimizeBetSlip !== minimize) {
      if (minimize) {
        globalStore.removeVisibleModalList('matchupStore:minimizeBetSlip')
      } else {
        globalStore.addVisibleModalList('matchupStore:minimizeBetSlip')
      }
    }
    this.minimizeBetSlip = minimize
    return minimize
  }

  @action
  toggleChangeRateCollapsed = (collapsed: boolean) => {
    this.collapsedChangeRate = collapsed
    return collapsed
  }

  @action
  addViewController = (
    matchId: number,
    marketType: string,
    clearField: () => void,
    setEnabled: (enabled: boolean) => void,
    updateField: () => void,
    setEnabledHome?: (enabled: boolean) => void,
    setEnabledDraw?: (enabled: boolean) => void,
    setEnabledAway?: (enabled: boolean) => void,
    isTwoWay?: boolean,
    field?: string,
    oddsBlockType?: string,
    restoreOddsButtonGroupStateForCallFromParent?: (
      oddsBlockTypeParam: string,
      value: string,
      marketList: Schema$MarketBlock[],
      marketType: string,
      sportId: number,
    ) => void,
    setEnabledHomeFromViewController?: (enabled: boolean) => void,
    setEnabledAwayFromViewController?: (enabled: boolean) => void,
  ) => {
    let match = this.viewControllers[matchId]
    if (!match) {
      this.viewControllers[matchId] = {}
      match = this.viewControllers[matchId]
    }

    match[marketType] = {
      clearField,
      setEnabled,
      updateField,
      setEnabledHome,
      setEnabledDraw,
      setEnabledAway,
      isTwoWay,
      field,
      oddsBlockType,
      restoreOddsButtonGroupStateForCallFromParent,
      setEnabledHomeFromViewController,
      setEnabledAwayFromViewController,
    }
  }

  @action
  clearViewControllers = () => {
    this.viewControllers = {}
  }

  getMarketBlocks = (
    regulars: Schema$MarketTrack[],
    irregulars: Schema$MarketTrack[],
    type: number,
    specifiers: { [id: string]: string },
  ): MarketBlock[] => {
    const marketId = String(type)
    const marketBlocks: MarketBlock[] = []
    let marketBlock: MarketBlock

    marketBlock = this.findMarketBlock(regulars, marketId, specifiers)
    if (marketBlock) {
      marketBlocks.push(marketBlock)
    }

    marketBlock = this.findMarketBlock(irregulars, marketId, specifiers)
    if (marketBlock) {
      marketBlocks.push(marketBlock)
    }

    return marketBlocks
  }

  @action
  updateRollbackOldRateDetail = (changeMarkets: ChangeOldMarket[]) => {
    setTimeout(() => {
      runInAction(() => {
        if (this.detailTrack) {
          const matchTrack = this.detailTrack.track
          for (const changeMarket of changeMarkets) {
            const marketBlocks: MarketBlock[] = this.getMarketBlocks(
              matchTrack.regulars,
              this.detailTrack.track.irregulars,
              changeMarket.type,
              changeMarket.specifiers,
            )

            if (marketBlocks.length > 0) {
              for (const oldOutcome of changeMarket.oldOutComes) {
                marketBlocks.forEach((marketBlock) => {
                  const outcome = marketBlock.outcomes.find(value => {
                    return value.type === oldOutcome.type
                  })
                  if (outcome) {
                    outcome.oldRate = oldOutcome.oldRate
                  }
                })
              }
            }
          }
        }
      })
    }, 10000)
  }

  @action
  updateRollbackOldRate = (outcomes: Schema$Outcome[]) => {
    setTimeout(() => {
      runInAction(() => {
        for (const i of outcomes) {
          i.oldRate = i.rate
        }
      })
    }, 2000)
  }

  @action
  updateMatchTrackStatus = (data: INotifyUnifiedStatus.Schema, matchTrack: MatchTrack) => {
    // matchStatus 업데이트
    if (data.matchStatusName != null) {
      matchTrack.matchStatusCode = data.matchStatus
      matchTrack.matchStatusName = data.matchStatusName.ko ?? data.matchStatusName.en ?? ''
    }

    matchTrack.statusCode = data.status
    matchTrack.homeScore = data.homeScore
    matchTrack.awayScore = data.awayScore
    if (data.periodScores) {
      matchTrack.periodScores = data.periodScores
    }
  }

  findMarketBlock = (tracks: MarketTrack[], marketId: string, specifiers: { [id: string]: string }) => {
    const marketBlocks = tracks.find(value => {
      return value.type === marketId && value.marketProvider === this.getMarketProvider()
    })
    if (marketBlocks == null) {
      return null
    }
    return marketBlocks.markets.find(value => _.isEqual(value.specifiers, specifiers))
  }

  // NOTE : 상세페이지(detailmarket) 갱신용으로 함수 추가
  @action
  updateDetailMatchTrack = (data: INotifyUnifiedFeed.Schema, matchTrack: MatchTrack) => {
    if (data.type === 'OddsChange') {
      console.log(
        `receive odds change detail : ${new Date(data.created).toLocaleTimeString()}, ${matchTrack.matchId}, ${
          data.markets.length
        }`,
      )

      const changedMarkets: ChangeOldMarket[] = []
      for (const market of data.markets || []) {
        if (market.marketProvider !== this.getMarketProvider()) {
          continue
        }
        const marketBlocks: MarketBlock[] = this.getMarketBlocks(
          matchTrack.regulars,
          this.detailTrack.track.irregulars,
          market.id,
          market.specifiers,
        )

        marketBlocks.forEach((marketBlock) => {
          const changedMarket: ChangeOldMarket = {
            type: market.id,
            specifiers: market.specifiers,
            oldOutComes: [],
          }

          marketBlock.status = market.status
          for (let i = 0; i < market.outcomeOdds.length; i += 1) {
            const newOutcome = market.outcomeOdds[i]
            const outcome = marketBlock.outcomes.find(value => {
              return value.type === newOutcome.id
            })
            if (outcome) {
              outcome.isActive = newOutcome.isActive
              if (outcome.rate !== newOutcome.odds) {
                outcome.rate = newOutcome.odds
                const oldOutCome: OldOutCome = {
                  type: newOutcome.id,
                  oldRate: newOutcome.odds,
                  metaId: newOutcome.metaId,
                }
                changedMarket.oldOutComes.push(oldOutCome)
              }
            }
          }

          if (changedMarket.oldOutComes.length > 0) {
            const foundChangeMarket = _.find(changedMarkets, (changedMarketEl) => {
              return changedMarketEl.type === market.id && changedMarketEl.specifiers === market.specifiers
            })

            if (!foundChangeMarket) {
              changedMarkets.push(changedMarket)
            }
          }
        })
      }

      if (changedMarkets.length > 0) {
        this.updateRollbackOldRateDetail(changedMarkets)
      }
    }
  }

  @action
  updateMatchTrack = (data: INotifyUnifiedFeed.Schema, matchTrack: MatchTrack) => {
    if (data.type === 'OddsChange') {
      const matchId = matchTrack.matchId
      const marketSize = _.size(data.markets)
      const feedSupplier = data.feedSupplier
      const marketProvider = _.isEmpty(data.markets) ? 'unknown' : data.markets[0].marketProvider
      console.log(`receive odds change : ${new Date(data.created).toLocaleTimeString()}, matchId: ${matchId}, marketSize: ${marketSize}, feedSupplier: ${feedSupplier}, marketProvider: ${marketProvider}`)
      const changedOutcomes: Schema$Outcome[] = []
      for (const market of data.markets || []) {
        if (market.marketProvider !== this.getMarketProvider()) {
          continue
        }
        const marketBlocks: MarketBlock[] = this.getMarketBlocks(
          matchTrack.regulars,
          matchTrack.irregulars,
          market.id,
          market.specifiers,
        )

        _.forEach(marketBlocks, (marketBlock) => {
          marketBlock.status = market.status
          for (let i = 0; i < market.outcomeOdds.length; i += 1) {
            const newOutcome = market.outcomeOdds[i]
            const outcome = marketBlock.outcomes.find(value => {
              return value.type === newOutcome.id
            })
            if (outcome) {
              outcome.isActive = newOutcome.isActive
              if (outcome.rate !== newOutcome.odds) {
                outcome.oldRate = outcome.rate
                outcome.rate = newOutcome.odds
                outcome.metaId = newOutcome.metaId
                changedOutcomes.push(outcome)
              }
            }
          }
        })
      }

      if (changedOutcomes.length > 0) {
        this.updateRollbackOldRate(changedOutcomes)
      }
    }
  }

  @action
  updateTrack = (data: INotifyUnifiedFeed.Schema) => {
    for (const track of this.tracks) {
      if (track.sportId === data.sportId) {
        const existsMatch = _.find(track.matches, { matchId: data.matchId })
        if (existsMatch) {
          this.updateMatchTrack(data, existsMatch)
          break
        }
      }
    }

    this.tracks = [].concat(this.tracks)
  }

  @action
  updateTrackStatus = (data: INotifyUnifiedStatus.Schema) => {
    for (const track of this.tracks) {
      if (track.sportId === data.sportId) {
        const existsMatch = _.find(track.matches, { matchId: data.matchId })
        if (existsMatch) {
          this.updateMatchTrackStatus(data, existsMatch)
          break
        }
      }
    }

    this.tracks = [].concat(this.tracks)
  }

  @action
  updateCartOdds = (data: INotifyUnifiedFeed.Schema) => {
    const cartItem = this.cart.find(item => item.matchId === data.matchId)
    if (cartItem) {
      const marketType = cartItem.marketType
      if (data.markets) {
        const market = data.markets.find(item => {
          return (item.id === Number(marketType)
            && _.isEqual(item.specifiers, cartItem.specifiers)
            && item.marketProvider === this.getMarketProvider())
        })
        if (market && market.outcomeOdds) {
          const outcome = market.outcomeOdds.find(odd => odd.id === cartItem.selectedOutcome.type)
          if (outcome) {
            if (cartItem.rate !== outcome.odds) {
              cartItem.rate = outcome.odds
              cartItem.outcomeMetaId = this.feedSupplier === FEED_SUPPLIER.LSPORTS ? outcome.metaId : outcome.id
              this.updateSelectedCartValue(cartItem)
              this.toggleCartUpdated()
            }
          }
        }
      }
    }
  }

  @action
  updateCartMatch = (data: INotifyUnifiedStatus.Schema) => {
    const cartItem = this.cart.find(item => item.matchId === data.matchId)
    if (cartItem) {
      const { status, matchStatus, matchStatusName } = data
      _.assign(cartItem.match, {
        status,
        matchStatus,
        matchStatusName: matchStatusName.ko || matchStatusName.en || '',
      })
    }
  }

  @action
  updateDetailTrack = async (data: INotifyUnifiedFeed.Schema) => {
    if (this.detailTrack != null && this.detailTrack.track.matchId === data.matchId) {
      this.updateDetailMatchTrack(data, this.detailTrack.track)
      runInAction(() => {
        this.detailTrack.track = { ...this.detailTrack.track }
      })
    }
  }

  @action
  updateDetailTrackStatus = (data: INotifyUnifiedStatus.Schema) => {
    if (this.detailTrack != null && this.detailTrack.track.matchId === data.matchId) {
      this.updateMatchTrackStatus(data, this.detailTrack.track)
      this.detailTrack.track = { ...this.detailTrack.track }
    }
  }

  @action
  updateUnifiedFeed = (data: INotifyUnifiedFeed.Schema) => {
    if (data.producerId !== this.producerId) {
      return
    }

    this.updateTrack(data)
    this.updateDetailTrack(data)
    this.updateCartOdds(data)
  }

  @action
  updateUnifiedStatus = (data: INotifyUnifiedStatus.Schema) => {
    console.log(
      `receive status data : ${new Date().toLocaleTimeString()}, ${data.matchId}, ${data.matchStatusName?.ko}, ${
        data.homeScore
      }:${data.awayScore}`,
    )

    this.updateTrackStatus(data)
    this.updateDetailTrackStatus(data)
    this.updateCartMatch(data)
  }

  @action
  changeClubId = (clubId: string, tabName = 'cross', moveToMatchupPage = true) => {
    if (clubId) {
      let targetClubId = clubId
      const userInfo = authStore.userInfo
      if (userInfo && userInfo.isSpecificClubMember && userInfo.clubId !== clubId) {
        targetClubId = userInfo.clubId
      }
      StorageUtils.saveLastClubId(targetClubId)
      if (moveToMatchupPage) {
        const hashParameters = getAllHashParameters(true)
        loadOrReload(`/matchup/${tabName}/${targetClubId}${hashParameters}`)
      }

      this.fetchMatchupClub({ clubId: targetClubId }).catch(console.error)
      authStore.checkAdultAuthentication().catch(console.error)
    }
  }

  @action
  isAvailableLiveMatch = (clubId: string, gameType: GAME_TYPE): boolean => {
    if (!clubId) {
      return false
    }
    if (gameType === GAME_TYPE.LIVE) {
      if (!this.enabledClubLiveLicense) {
        return false
      }
      const liveMatchAvailableClubsSetting = globalStore.findGlobalSetting(GlobalStoreKey.LIVE_MATCH_AVAILABLE_CLUBS)
      if (liveMatchAvailableClubsSetting) {
        const liveMatchAvailableClubs: string[] = liveMatchAvailableClubsSetting.value.split(',')
        return liveMatchAvailableClubs.includes('all') || liveMatchAvailableClubs.includes(clubId)
      }
    }

    return true
  }

  // 웹소켓이 붙을때 마다 최신배당률로 올드배당률을 갱신시켜준다.
  @action
  updateOldRateFromCurrentRate = () => {
    if (this.tracks) {
      for (const track of this.tracks) {
        for (const match of track.matches) {
          for (const markets of match.regulars) {
            for (const market of markets.markets) {
              for (const outcome of market.outcomes) {
                outcome.oldRate = outcome.rate
              }
            }
          }
        }
      }
    }

    if (this.detailTrack) {
      for (const markets of this.detailTrack.track.irregulars) {
        for (const market of markets.markets) {
          for (const outcome of market.outcomes) {
            outcome.oldRate = outcome.rate
          }
        }
      }
    }
  }

  getCart = (selectedValue: string): CartItem | undefined => {
    const cart = _.find(this.cart, (item) => item.value === selectedValue)
    return cart
  }

  getSelectedField = (matchId: number, marketType: string): string => {
    const cartItem = _.find(this.activeCart, (item) => item.matchId === matchId && item.marketType === marketType)
    if (cartItem) {
      return cartItem.value
    }
    return ''
  }

  getSameMatchCartList = (): CartItem[] => {
    if (!this.selectedCartParams) {
      return []
    }

    const filters = _.filter(this.cart, { matchId: this.selectedCartParams.matchId })
    return filters
  }

  setSelectedCartParams = (
    tournamentId: number, matchId: number, value: string,
    cartClearCallback?: () => void,
  ) => {
    this.selectedCartParams = {
      matchId,
      tournamentId,
      value,
      cartClearCallback,
    }
  }

  addSelectedCartItem = (executeToggleCartUpdated = true): void => {
    this.addCartItem(
      this.selectedCartParams.tournamentId,
      this.selectedCartParams.matchId,
      this.selectedCartParams.value,
      executeToggleCartUpdated,
    )
  }

  addSelectedDetailCartItem = (executeToggleCartUpdated = true): void => {
    this.addDetailCartItem(
      this.selectedCartParams.tournamentId,
      this.selectedCartParams.matchId,
      this.selectedCartParams.value,
      executeToggleCartUpdated,
    )
  }

  setBetParamsSinglePenalty(params: IBet.Params) {
    if (params && params.betCalls.length > 0) {
      params.betCalls[0].outcomeRate = getSingleBetPenaltyRate(
        Number(params.betCalls[0].outcomeRate), authStore.userInfo?.id,
      ).toString()
    }
  }

  isMainMarket = (marketType: string): boolean => {
    let main_types = this.producerId === ProducerType.LIVEODDS ? WDL_MARKET_TYPES : CROSS_TYPES
    if (this.feedSupplier === FEED_SUPPLIER.LSPORTS) {
      main_types = this.producerId === ProducerType.LIVEODDS ? LS_WDL_MARKET_TYPES : LS_CROSS_TYPES
    }
    return main_types.indexOf(Number(marketType)) >= 0
  }

  isPossibleMultiBet = (matchId: number, marketType: string): boolean => {
    let isPossible = true
    if (this.cart.length > 0) {
      const matches = _.filter(this.cart, (item) => item.matchId === matchId)
      if (matches.length > 0) {
        const isSelectedMainMarket = this.isMainMarket(marketType)
        for (const match of matches) {
          const isCartMainMarket = this.isMainMarket(match.marketType)
          if (isSelectedMainMarket !== isCartMainMarket) {
            isPossible = false
            break
          }
        }
      }
    }

    return isPossible
  }

  @action
  toggleCartUpdated = () => {
    this.cartUpdated = !this.cartUpdated
  }

  @action
  fetchMatchChangeTournamentTracks = async (params: IMatchupTracks.Params) => {
    try {
      this.isTournamentTrackLoading = true
      const result = await this.api.game.getGameTournamentTracks(params)
      runInAction(() => {
        this.isTournamentTrackLoading = false
      })
      const { error } = result
      if (error === DUPLICATE_REQUEST_EXCEPTION) {
        return
      }

      runInAction(() => {
        if (this.matchChangeTournamentTracks) {
          result.tracks.forEach((newTrack) => {
            const existingTrack
              = this.matchChangeTournamentTracks.find(track => track.tournamentId === newTrack.tournamentId)

            if (existingTrack) {
              existingTrack.matches = [
                ...existingTrack.matches,
                ...newTrack.matches,
              ]
            } else {
              this.matchChangeTournamentTracks.push(newTrack)
            }
          })
        } else {
          this.matchChangeTournamentTracks = result.tracks
        }

        this.matchChangeHasMore = result.hasMore
        this.matchChangeTournamentTracksStartDate = result.startDate
        this.matchChangeLastOrderId = _.toString(result.lastOrderId)
      })
    } catch (err) {
      console.error(err)
    }
  }

  @action
  resetMatchChangeTournamentTracksStartDate = () => {
    this.matchChangeTournamentTracksStartDate = undefined
  }

  resetMatchChangeTournamentTracks = () => {
    this.matchChangeTournamentTracks = undefined
  }

  toggleFavoriteMatch = async (params: IFavoriteMatch.Params): Promise<boolean> => {
    let isAdded: boolean
    try {
      const result = await this.api.game.toggleFavoriteMatch(params)
      isAdded = result.isAdded
    } catch (err) {
      console.error(err)
      // TODO 찜 등록 실패 시 에러 메시지 출력
    }
    return isAdded
  }

  makeFavoriteMatchListParam = (track: TournamentTrack, isFavorite: boolean): IFavoriteMatchList.Params => {
    const { sportId, matches } = track

    const params: IFavoriteMatchList.Params = {
      isFavorite,
      matchList: _.map(matches, match => {
        return {
          sportId,
          matchId: match.matchId,
          dateOfMatch: match.dateOfMatch,
        }
      }),
    }

    return params
  }

  @action
  toggleFavoriteMatchList = async (track: TournamentTrack, isFavorite: boolean): Promise<boolean> => {
    let isTournamentFavorite = false
    const { matches } = track

    const params = this.makeFavoriteMatchListParam(track, isFavorite)
    try {
      const result = await this.api.game.toggleFavoriteMatchList(params)

      runInAction(() => {
        isTournamentFavorite = result.isFavorite

        _.forEach(matches, match => {
          const { matchId } = match

          if (isTournamentFavorite && !_.includes(this.favoriteMatchIds, matchId)) {
            this.addFavoriteMatchId(matchId)
            this.increaseFavoriteMatchCount()
            this.increaseFavoriteTotalPreMatchCount()
          } else if (!isTournamentFavorite && _.includes(this.favoriteMatchIds, matchId)) {
            this.removeFavoriteMatchId(matchId)
            this.decreaseFavoriteMatchCount()
            this.decreaseFavoriteTotalPreMatchCount()
          }
        })
      })
    } catch (err) {
      console.error(err)
    }

    return isTournamentFavorite
  }

  @action
  decreaseFavoriteMatchCount() {
    if (this.favoriteMatchCount > 0) {
      this.favoriteMatchCount -= 1
    }
  }

  @action
  increaseFavoriteMatchCount() {
    if (_.isNil(this.favoriteMatchCount)) {
      this.favoriteMatchCount = 0
    }
    this.favoriteMatchCount += 1
  }

  @action
  addFavoriteMatchId(matchId: number): void {
    if (_.isNil(this.favoriteMatchIds)) {
      this.favoriteMatchIds = _.concat([], [matchId])
    } else {
      this.favoriteMatchIds = _.concat(this.favoriteMatchIds, [matchId])
    }
  }

  @action
  setFavoriteTotalPreMatchCount(favoriteTotalPreMatchCount: number): void {
    this.favoriteTotalPreMatchCount = favoriteTotalPreMatchCount
  }

  @action
  removeFavoriteMatchId(matchId: number): void {
    _.remove(this.favoriteMatchIds, m => m === matchId)
    this.favoriteMatchIds = [].concat(this.favoriteMatchIds)
  }

  @action
  removeTrackInTracksByMatchId(matchId: number) {
    if (!_.isEmpty(this.tracks)) {
      const rejectTrackIds = []
      _.forEach(this.tracks, track => {
        track.matches = _.reject(track.matches, match => match.matchId === matchId)
        if (_.isEmpty(track.matches)) {
          rejectTrackIds.push(track.id)
        }
      })
      this.tracks = _.reject(this.tracks, track => rejectTrackIds.includes(track.id))
    }
    this.makeTournamentTrackMatchInfos(this.pageType) // 띠배너 위치를 계산하기 위한 맵생성
  }

  @action
  toggleFavoriteMarket = async (sportId: number, marketType: string, periodValues: string) => {
    try {
      const params: IFavoriteMarket.Params = {
        producerType: this.producerId,
        sportId,
        marketType,
        periodValues: periodValues || '',
      }

      const result = await this.api.game.toggleFavoriteMarket(params)
      runInAction(() => {
        if (result.isAdded) {
          this.favoriteMarkets.marketTypes.push({ marketType, periodValues })
        } else {
          const index = this.findIndexFavoriteMarket(marketType, periodValues)
          this.favoriteMarkets.marketTypes.splice(index, 1)
        }
      })
    } catch (err) {
      console.error(err)
    }
  }

  @action
  updateFavoriteMarkets = async (sportId: number) => {
    try {
      const params: IFavoriteMarkets.Params = {
        producerType: this.producerId,
        sportId,
      }

      const result = await this.api.game.favoriteMarkets(params)
      runInAction(() => {
        this.favoriteMarkets = result.favoriteMarkets
      })
    } catch (err) {
      console.error(err)
    }
  }

  findIndexFavoriteMarket = (marketType: string, periodValues: string) => {
    return this.favoriteMarkets?.marketTypes.findIndex(market => {
      return market.periodValues === periodValues && market.marketType === marketType
    })
  }

  isFavoriteMarket = (marketType: string, periodValues: string) => {
    const index = this.findIndexFavoriteMarket(marketType, periodValues)
    return index > -1
  }

  realClickEventSuccessBet = () => {
    const dspu = 'JX0aXZlbnRvcnk'      // === (필수)광고주key (변경하지마세요) ===
    const dspt = '1'         // === (필수)전환구분( 1:구매 ) (변경하지마세요) ===
    const dspo = ''          // === (선택)주문번호( 미입력시 - 중복체크 안함. ) ===
    const dspom = ''        // === (선택)구매금액( 구매전환시 사용 ) ===
    loadanal_dsp(`tk.realclick.co.kr/tk_comm.js?dspu=${dspu}&dspt=${dspt}&dspo=${dspo}&dspom=${dspom}`)
  }

  googleAdsEventSuccessFirstBet = () => {
    const eventId = 'AmHSCIust5MCEKPH4ccC' // === (필수) GoogleAds: 이벤트 Key ===
    const transactionId = '' // === (선택)주문번호( 미입력시 - 중복체크 안함. ) ===
    loadGoogleAdsJS_gtagReportConversion(eventId, transactionId)
  }

  mobileAppRecordEventByFirstBet = (isFirstBet: boolean): void => {
    if (!isMobile) {
      return
    }

    if (!isFirstBet) {
      return
    }

    if (window.android) {
      window.android.recordEvent(MOBILE_APP_RECORD_EVENT.FIRST_BET_BY_CIVALUE, JSON.stringify({ isFirstBet: true }))
    }
  }

  onClickMatchupPopupFilter = (uniqueId: number) => {
    this.setMajorUniqueID(uniqueId)
  }

  @action
  setUseBetSlipRefreshButtonInsteadOfBettingButton = (useBetSlipRefreshButtonInsteadOfBettingButton: boolean) => {
    this.useBetSlipRefreshButtonInsteadOfBettingButton = useBetSlipRefreshButtonInsteadOfBettingButton
  }

  incrementPreMatchBetSuccessCountAfterBetSlipOpened = () => {
    this.preMatchBetSuccessCountAfterBetSlipOpened += 1
  }

  resetPreMatchBetSuccessCountAfterBetSlipOpened = () => {
    this.preMatchBetSuccessCountAfterBetSlipOpened = 0
  }

  clearFieldOddsInViewControllerByCartItem = (cartItem: CartItem) => {
    const { matchId, marketType } = cartItem

    const vcMatch = this.viewControllers[matchId]
    if (vcMatch) {
      const vcOdds = vcMatch[marketType]
      if (vcOdds) {
        vcOdds.clearField()
      }
    }
  }

  @action
  setUnreadClubMessageCount = (count: number) => {
    this.unreadClubMessageCount = count
  }

  @action
  setFeedSupplier = (feedSupplier: FEED_SUPPLIER): void => {
    this.feedSupplier = feedSupplier
  }

  @action
  setMarketProvider = (marketProvider: MARKET_PROVIDER): void => {
    switch (this.currentGameKey) {
      case GAME_TYPE.LIVE:
        this.marketProviderData.live = marketProvider
        break
      default:
        this.marketProviderData.pre = marketProvider
    }
  }

  @action
  setMarketProviderData = (marketProviderData: SportsFeedMarketProvider): void => {
    this.marketProviderData = marketProviderData
  }

  /**
   * 20초 마다 마켓프로바이더를 호출한다.
   * 대부분은 클라이언트에 전달된 글로벌값이나 토너먼트 트랙 호출시 함께 전달되는 값으로 충분하지만
   * 간혹 클라이언트 새로고침을 하지 않아 이전 데이터를 계속 바라보는 경우가 있어 추가함.
   */
  @action
  refreshFeedSupplierAndMarketProvider = async () => {
    try {
      const res = await this.api.game.getMarketProvider()
      if (!_.isNil(res)) {
        if (_.isNil(this.getMarketProvider())) {
          this.setMarketProviderData(res.marketProvider)
        } else if (!_.isEqual(res.marketProvider, this.marketProviderData)) {
          window.location.href = '/'
        }
        const feedSupplier = res.marketProvider.pre > 0 ? FEED_SUPPLIER.LSPORTS : FEED_SUPPLIER.BET_RADAR
        if (_.isNil(this.feedSupplier)) {
          this.setFeedSupplier(feedSupplier)
        } else if (feedSupplier !== this.feedSupplier) {
          window.location.href = '/'
        }
      }
    } catch (err) {
      console.error(`refreshFeedSupplierAndMarketProvider error: ${err}`)
    }
  }

  getMarketAndOutcomeInTournamentTracks = (
    matchId: number, tournamentId: number, marketType: string, specifiers: string, outcomeType: string,
  ) => {
    let foundMarket = null
    let foundOutcome = null

    if (_.includes(GAME_TYPE_REGULAR_FILTER.cross, marketType)) {
      let tours = _.filter(this.tracks, { tournamentId }) as TournamentTrack[]

      if (!_.isNil(this.tournamentFilterList)) {
        tours = _.filter(this.filteredTracks, { tournamentId }) as TournamentTrack[]
      }

      for (const tour of tours) {
        const match = _.find(tour.matches, { matchId }) as MatchTrack
        if (match) {
          let market: Schema$MarketTrack
          // 동일한 마켓타입 항목이 많은 경우, playingPeriodInfo 을 기준으로 대상 마켓을 찾아야 한다.
          const filteredMarkets = match.regulars.filter(regulars => regulars.type === marketType)
          if (_.size(filteredMarkets) > 1) {
            const playingPeriodInfos = this.getPlayingPeriodInfos(specifiers)
            market = filteredMarkets.find(filteredMarket => {
              return _.isEqual(filteredMarket.playingPeriodInfos, playingPeriodInfos)
            })
          } else {
            market = match.regulars.find(irregulars => irregulars.type === marketType)
          }

          const findMarketOutcome = this.findMarketOutcomeBySpecifiers(market.markets, specifiers, outcomeType)
          foundMarket = findMarketOutcome.foundMarket
          foundOutcome = findMarketOutcome.foundOutcome
        }
      }
    } else { // 상세 BET의 마켓일 경우
      const match = this.detailTrack.track
      if (!match) {
        return null
      }
      let market: Schema$MarketTrack
      const filteredMarkets = match.irregulars.filter(irregulars => irregulars.type === marketType)

      // 동일한 마켓타입 항목이 많은 경우, playingPeriodInfo 을 기준으로 대상 마켓을 찾아야 한다.
      if (_.size(filteredMarkets) > 1) {
        const playingPeriodInfos = this.getPlayingPeriodInfos(specifiers)
        market = filteredMarkets.find(filteredMarket => {
          return _.isEqual(filteredMarket.playingPeriodInfos, playingPeriodInfos)
        })
      } else {
        market = match.irregulars.find(irregulars => irregulars.type === marketType)
      }

      const findMarketOutcome = this.findMarketOutcomeBySpecifiers(market.markets, specifiers, outcomeType)
      foundMarket = findMarketOutcome.foundMarket
      foundOutcome = findMarketOutcome.foundOutcome
    }
    return { market: foundMarket, outcome: foundOutcome }
  }

  getPlayingPeriodInfos = (specifiers: string): { key: string; value: any }[] => {
    const specifiersObject = JSON.parse(specifiers)
    const playingPeriodInfos = []
    for (const key of Object.keys(specifiersObject)) {
      if (_.includes(PlayingPeriodSpecifierKey, key)) {
        playingPeriodInfos.push({ key, value: specifiersObject[key] })
      }
    }
    return playingPeriodInfos
  }

  findMarketOutcomeBySpecifiers = (
    markets: Schema$MarketBlock[], specifiers: string, outcomeType: string,
  ): { foundMarket: Schema$MarketBlock | null, foundOutcome: Schema$Outcome | null } => {
    let foundMarket = null
    let foundOutcome = null
    const specifiersObject = JSON.parse(specifiers)
    const selectedSpecKeys = _.keys(specifiersObject)
    for (const tempMarket of markets) {
      if (_.size(markets) === 1) {
        foundOutcome = tempMarket.outcomes.find(outcome => outcome.type === outcomeType)
        if (foundOutcome) {
          foundMarket = tempMarket
        }
      } else {
        // 선택한기준점(specifiers)과 같은 specifiers 를 가진 market 을 대상으로 선택한 아웃컴을 찾아야 한다.
        const tempMarketSpecKeys = _.keys(tempMarket.specifiers)
        if (_.size(tempMarketSpecKeys) !== _.size(_.keys(selectedSpecKeys))) {
          continue
        }
        let isEqualSpecifiers = true
        for (const tempMarketSpecKey of tempMarketSpecKeys) {
          if (tempMarket.specifiers[tempMarketSpecKey] !== specifiersObject[tempMarketSpecKey]) {
            isEqualSpecifiers = false
          }
        }
        if (!isEqualSpecifiers) {
          continue
        }
        foundOutcome = tempMarket.outcomes.find(outcome => outcome.type === outcomeType)
        if (foundOutcome) {
          foundMarket = tempMarket
        }
      }
    }
    return { foundMarket: foundMarket, foundOutcome: foundOutcome }
  }

  setIsNeedToFavoriteMatchIdsWhenFetchTournamentTracks = (needToFavoriteMatchIds: boolean) => {
    this.isNeedToFavoriteMatchIdsWhenFetchTournamentTracks = needToFavoriteMatchIds
  }

  @action
  setMatchTabInitializeMajorUniqueId = (id) => {
    this.matchTabInitializeMajorUniqueId = id
  }

  @action
  setMatchTabInitializeSportId = (id) => {
    this.matchTabInitializeSportId = id
  }

  fetchFavoriteTotalPreMatchCount = async () => {
    if (!authStore.isSignedIn) {
      return
    }

    try {
      const { favoriteMatchCount } = await this.api.game.fetchFavoriteMatchCount()
      this.setFavoriteTotalPreMatchCount(favoriteMatchCount)
    } catch (err) {
      console.error(err)
    }
  }

  @action
  increaseFavoriteTotalPreMatchCount = () => {
    if (_.isNil(this.favoriteTotalPreMatchCount)) {
      this.favoriteTotalPreMatchCount = 0
    }
    this.favoriteTotalPreMatchCount += 1
  }

  @action
  decreaseFavoriteTotalPreMatchCount = () => {
    if (this.favoriteTotalPreMatchCount > 0) {
      this.favoriteTotalPreMatchCount -= 1
    }
  }

  @action
  updateIsFavoritePreMatchInTournamentTracks = (matchId: number, isFavoriteMatch: boolean): void => {
    let isUpdated = false

    let isTournamentFliter = false
    let targetTracks = this.tracks

    if (!_.isNil(this.tournamentFilterList)) {
      isTournamentFliter = true
      targetTracks = this.filteredTracks
    }

    _.forEach(targetTracks, track => {
      const matchTracks = track?.matches
      _.forEach(matchTracks, matchTrack => {
        if (matchTrack.matchId === matchId) {
          isUpdated = true
          matchTrack.isFavorite = isFavoriteMatch
          if (isFavoriteMatch) {
            this.addFavoriteMatchId(matchId)
            this.increaseFavoriteMatchCount()
          } else {
            this.removeFavoriteMatchId(matchId)
            this.decreaseFavoriteMatchCount()
            if (this.currentGameKey === GAME_TYPE.CROSS
              && this.majorUniqueID === EXCEPTIONAL_UNIQUE_ID.FAVORITE_MATCH) {
              this.removeTrackInTracksByMatchId(matchId)
            }
          }
        }
      })

      if (isTournamentFliter) {
        this.updateIsTournamentFavoriteInTournamentTrack(track)
      }
    })

    // 현재 매치 리스트에 찜 상태가 변경된 항목이 없는데, 스포츠 - 전체 탭인 경우 좋아요 수를 증가해야 한다.
    if (!isUpdated && this.currentGameKey === GAME_TYPE.CROSS && this.sportTab === 0) {
      if (isFavoriteMatch) {
        this.addFavoriteMatchId(matchId)
        this.increaseFavoriteMatchCount()
      } else {
        this.removeFavoriteMatchId(matchId)
        this.decreaseFavoriteMatchCount()
      }
    }
  }

  @action
  updateIsFavoriteMatchByMatchTracks = (matchTracks: MatchTrack[], isFavorite: boolean) => {
    _.forEach(matchTracks, match => {
      match.isFavorite = isFavorite
    })
  }

  @action
  updateIsTournamentFavoriteInTournamentTrack = (track: TournamentTrack) => {
    const { matches } = track
    const nonFavoriteMatch = _.find(matches, match => !_.includes(this.favoriteMatchIds, match.matchId))

    track.isTournamentFavorite = _.size(nonFavoriteMatch) === 0
  }

  existCartItem = (matchId: number, marketType: string, specifiers: string, selection: string): boolean => {
    const existCartItem = _.find(this.cart, cartItem => {
      if (Mining.isRegularMarket(BET_TYPE_ON.UNIFIED_MATCH, cartItem.marketType)) {
        return cartItem.matchId === matchId
          && cartItem.marketType === marketType
          && JSON.stringify(cartItem.specifiers) === specifiers
          && cartItem.selection === selection
      }
      return cartItem.matchId === matchId
    })

    return !!existCartItem
  }

  @action
  resetTournamentFilterList = () => {
    if (_.isNil(this.tournamentFilterList)) {
      return
    }

    this.tournamentFilterList = undefined

    this.updateTracksByFilteredTracks()
    this.restoreMatchupListState()
    this.toggleCartUpdated()
  }

  @action
  setTournamentFilterList = (tournamentIds: number[]): void => {
    this.tournamentFilterList = tournamentIds
  }

  getProcessingMatchIds = (): number[] => {
    const matchIds: number[] = []
    const allTracks = [...(this.tracks || []), ...(this.filteredTracks || [])]
    for (const track of allTracks) {
      for (const match of (track.matches || [])) {
        if (match.statusCode === MATCH_GAME_STATUS.Live) {
          matchIds.push(match.matchId)
        }
      }
    }
    return _.uniq(matchIds)
  }

  @action
  applyScoreRefresh = (matches: import('@protocol/game').IScoreRefresh.MatchScore[]): void => {
    if (_.isEmpty(matches)) return
    const matchMap = new Map(matches.map(m => [m.matchId, m]))
    const allTracks = [...(this.tracks || []), ...(this.filteredTracks || [])]
    for (const track of allTracks) {
      for (const match of (track.matches || [])) {
        const updated = matchMap.get(match.matchId)
        if (!updated) continue
        match.homeScore = updated.homeScore
        match.awayScore = updated.awayScore
        match.matchStatusCode = updated.matchStatusCode
        match.matchStatusName = updated.matchStatusName
        match.statusCode = updated.statusCode
        match.statusName = updated.statusName
        match.periodScores = updated.periodScores
      }
    }
  }

  stopScoreRefreshPolling = (): void => {
    if (this.scoreRefreshTimer) {
      console.log('!==== stopScoreRefreshPolling')
      clearTimeout(this.scoreRefreshTimer)
      this.scoreRefreshTimer = null
    }
  }

  startScoreRefreshPolling = (): void => {
    if (this.pageType !== PAGE_TYPE.MATCHUP_RESULT && this.pageType !== PAGE_TYPE.MATCHUP_RESULT_FILTER) {
      return
    }
    this.stopScoreRefreshPolling()

    if (!this.scoreRefreshReactionDisposer) {
      this.scoreRefreshReactionDisposer = reaction(
        () => globalStore.findGlobalSetting(GlobalStoreKey.MATCHUP_RESULT_SCORE_REFRESH_INTERVAL_SEC)?.value,
        () => {
          if (this.scoreRefreshTimer !== null) {
            this.startScoreRefreshPolling()
          }
        },
      )
    }

    const getIntervalMs = () =>
      _.toNumber(
        globalStore.findGlobalSetting(GlobalStoreKey.MATCHUP_RESULT_SCORE_REFRESH_INTERVAL_SEC)?.value ?? 5,
      ) * 1000

    const poll = async () => {
      if (this.pageType !== PAGE_TYPE.MATCHUP_RESULT && this.pageType !== PAGE_TYPE.MATCHUP_RESULT_FILTER) {
        return
      }
      const matchIds = this.getProcessingMatchIds()
      if (!_.isEmpty(matchIds)) {
        try {
          const result = await this.api.game.getScoreRefresh({ matchIds })
          if (result?.matches) {
            this.applyScoreRefresh(result.matches)
          }
        } catch (e) {
          console.error(e)
        }
      }
      this.scoreRefreshTimer = setTimeout(poll, getIntervalMs())
    }

    this.scoreRefreshTimer = setTimeout(poll, getIntervalMs())
  }

  clearMatchListState = () => {
    this.matchupListStatus = {
      viewControllers: {},
      lastOrderId: '',
      hasMore: false,
      openedAt: undefined,
      filteredSelectedDetailTabs: undefined,  // ← 추가
    }
    this.filteredSelectedDetailTabs = []         // ← 추가
    this.filteredProcessedMatchCount = undefined // ← 추가
    this.filteredClosedMatchCount = undefined    // ← 추가
  }

  @action
  removeTournamentFilterListByTournamentId = (tournamentId: number): void => {
    if (!_.includes(this.tournamentFilterList, tournamentId)) {
      return
    }

    const filterList = _.reject(this.tournamentFilterList, el => el === tournamentId)
    this.setTournamentFilterList(filterList)
  }

  setMatchupListState = () => {
    this.matchupListStatus.viewControllers = _.cloneDeep(this.viewControllers)
    this.matchupListStatus.lastOrderId = this.lastOrderId
    this.matchupListStatus.hasMore = this.hasMore
    this.matchupListStatus.openedAt = new Date()
    // SCORE 리그필터 DetailTab을 현재 SCORE 페이지 탭 상태로 초기화
    const selectedDetailTabs = this.getActiveScorePageDetailTabs()
    this.matchupListStatus.filteredSelectedDetailTabs = [...selectedDetailTabs]
    this.filteredSelectedDetailTabs = [...selectedDetailTabs]
  }

  // setMatchupListState = () => {
  //   this.matchupListStatus.viewControllers = _.cloneDeep(this.viewControllers)
  //   this.matchupListStatus.lastOrderId = this.lastOrderId
  //   this.matchupListStatus.hasMore = this.hasMore
  //   this.matchupListStatus.openedAt = new Date()
  // }

  restoreMatchupListState = () => {
    this.viewControllers = _.cloneDeep(this.matchupListStatus.viewControllers)
    this.lastOrderId = this.matchupListStatus.lastOrderId || ''
    this.hasMore = this.matchupListStatus.hasMore || false
    this.filteredTracks = []

    this.clearMatchListState()
  }

  /**
   * 리그필터(filteredTracks)에 존재하는 경기 정보가 메인 매치업(tracks)에 존재할 경우
   * 리그필터 안의 경기정보로 tracks의 동일한 경기의 정보를 대체.
   * 이유: 리그필터에서 받은 경기정보가 tracks에 존재하는 경기정보 보다 최신 정보이므로,
   *     배당정보 및 마켓의 정보를 대체하는 목적
   */
  @action
  updateTracksByFilteredTracks = () => {
    _.forEach(this.tracks, track => {
      const { tournamentId, matches } = track
      const filterTrack = _.find(this.filteredTracks, el => el.tournamentId === tournamentId)

      if (!filterTrack) {
        return
      }

      _.forEach(matches, match => {
        const { matchId } = match
        const filterMatch = _.find(filterTrack.matches, el => el.matchId === matchId)

        if (!filterMatch) {
          return
        }

        filterMatch.isFavorite = _.includes(this.favoriteMatchIds, matchId)
        _.assign(match, filterMatch)
      })
    })
  }


  @action
  fetchFilteredTournamentTracks = async (params: SimpleFetchItemsParams): Promise<MatchupTrackData> => {
    const { limit, pageType, reset, isDetailTabChange } = params

    if (pageType !== PAGE_TYPE.MATCHUP_FILTER && pageType !== PAGE_TYPE.MATCHUP_RESULT_FILTER) {
      return null
    }

    if (_.isNil(this.tournamentFilterList)) {
      return null
    }

    try {
      const gameKey = this.currentGameKey
      const subKey = this.currentSportsKey

      if (Number(subKey) > 0 && this.currentSportId <= 0) {
        this.currentSportId = Number(subKey)
      }

      const sportId = this.currentSportId

      const copiedFavoriteMatchIds = toJS(this.favoriteMatchIds)

      let orderId = this.filteredTracks.length > 0 ? this.lastOrderId : undefined
      if (reset) {
        runInAction(() => {
          this.hasMore = true
          this.isLoading = true
          this.filteredTracks = []
          this.lastOrderId = undefined
        })

        orderId = undefined
      } else if (this.isLoading || (this.currentGameKey !== GAME_TYPE.LIVE && !this.hasMore)) {
        this.isLoading = false
        return null
      }

      const baseParams = {
        clubId: this.club.id,
        sportId,
        sportIdGroup: Number(subKey),
        gameType: gameKey,
        limit,
        pageType,
        orderId,
        favoriteMatchIds: copiedFavoriteMatchIds,
        uniqueIdGroup: EXCEPTIONAL_UNIQUE_ID.LEAGUE_FILTERED_MATCH,
        onlyIrregularCount: true,
        ignoreMatchupFilterList: true,
        isNeedToFavoriteMatchIdsWhenFetchTournamentTracks: false,
        tournamentIds: this.tournamentFilterList,
        openedAt: this.matchupListStatus.openedAt,
      }

      if (pageType === PAGE_TYPE.MATCHUP_RESULT_FILTER) {
        const filteredStatues: MATCH_GAME_STATUS[] = []
        const filteredSelectedDetailTabs = this.getActiveScorePageDetailTabs(true)

        if (filteredSelectedDetailTabs.includes(DETAIL_TAB.CLOSED)) {
          filteredStatues.push(MATCH_GAME_STATUS.Closed, MATCH_GAME_STATUS.Ended)
        }
        if (filteredSelectedDetailTabs.includes(DETAIL_TAB.PROCESSED)) {
          filteredStatues.push(MATCH_GAME_STATUS.Live)
        }

        if (filteredStatues.length === 0) {
          runInAction(() => {
            this.isLoading = false
            this.filteredTracks = []
            this.hasMore = false
          })
          return null
        }

        const result = await this.api.game.getGameTournamentTracks({
          ...baseParams,
          matchStatues: filteredStatues,
        })

        if (!isDetailTabChange && reset) {
          const processedCount = result.filteredProcessedMatchCount ?? 0
          const closedCount = result.filteredClosedMatchCount ?? 0
          const totalMatchCount = processedCount + closedCount

          runInAction(() => {
            this.filteredProcessedMatchCount = processedCount
            this.filteredClosedMatchCount = closedCount
          })

          if (totalMatchCount === 0) {
            runInAction(() => {
              this.isLoading = false
            })
            showToast(TOAST_TYPE.INFO, '확인가능한 경기가 없어 이동됩니다.')
            this.resetTournamentFilterList()
            return null
          }
        }

        const tournamentIds = _.map(result.tracks, 'tournamentId')
        const existingTrack = _.find(this.filteredTracks, track => {
          return _.includes(tournamentIds, track.tournamentId)
        })

        if (existingTrack) {
          const { isTournamentFavorite, tournamentId } = existingTrack
          const newTrack = _.chain(result.tracks)
            .remove({ tournamentId })
            .head()
            .value()

          if (newTrack) {
            if (isTournamentFavorite) {
              const { matches } = newTrack
              await this.toggleFavoriteMatchList(newTrack, true)
              this.updateIsFavoriteMatchByMatchTracks(matches, true)
            }

            runInAction(() => {
              existingTrack.matches = _.concat(existingTrack.matches, newTrack.matches)
              existingTrack.matchCount = newTrack.matchCount
              existingTrack.visible = newTrack.visible
            })
          }
        }

        runInAction(() => {
          this.isLoading = false
          this.hasMore = result.hasMore
          this.feedSupplier = result.feedSupplier
          this.marketProviderData = result.marketProviderData

          if (result.lastOrderId) {
            this.lastOrderId = _.toString(result.lastOrderId)
          }

          const trackList = _.concat([], this.filteredTracks)
          _.forEach(result.tracks, track => {
            this.updateIsTournamentFavoriteInTournamentTrack(track)
            trackList.push(track)
          })

          this.filteredTracks = trackList
          this.matchupBlockLeagueFilterBannerVisibleIndex = this.filteredTracks.length // 리그 필터는 매치리스트 하단에 배너 위치
          this.setIsBannerRendered(false)
          this.makeTournamentTrackMatchInfos(pageType) // 띠배너 위치를 계산하기 위한 맵생성
        })

        // 리그필터 초기 로드 시 진행중 경기 점수를 즉시 갱신 (첫 폴링 전 대시 표시 방지)
        const liveMatchIds = _.chain(result.tracks)
          .flatMap('matches')
          .filter(match => match.statusCode === MATCH_GAME_STATUS.Live)
          .map('matchId')
          .value()

        if (!_.isEmpty(liveMatchIds)) {
          try {
            const scoreResult = await this.api.game.getScoreRefresh({ matchIds: liveMatchIds })
            if (scoreResult?.matches) {
              this.applyScoreRefresh(scoreResult.matches)
            }
          } catch (e) {
            console.error('Failed to fetch score refresh', e)
          }
        }

        return null
      }

      const result = await this.api.game.getGameTournamentTracks({
        ...baseParams,
        matchStatues: [],
      })

      const tournamentIds = _.map(result.tracks, 'tournamentId')
      const existingTrack = _.find(this.filteredTracks, track => {
        return _.includes(tournamentIds, track.tournamentId)
      })

      if (existingTrack) {
        const { isTournamentFavorite, tournamentId } = existingTrack
        const newTrack = _.chain(result.tracks)
          .remove({ tournamentId })
          .head()
          .value()

        if (newTrack) {
          if (isTournamentFavorite) {
            const { matches } = newTrack
            await this.toggleFavoriteMatchList(newTrack, true)
            this.updateIsFavoriteMatchByMatchTracks(matches, true)
          }

          runInAction(() => {
            existingTrack.matches = _.concat(existingTrack.matches, newTrack.matches)
            existingTrack.matchCount = newTrack.matchCount
            existingTrack.visible = newTrack.visible
          })
        }
      }

      runInAction(() => {
        this.isLoading = false

        let matchCount = 0
        _.forEach(result.tracks, track => {
          matchCount += track.matches.length
        })

        if (reset && matchCount === 0) {
          showToast(TOAST_TYPE.INFO, '베팅가능한 경기가 없어 이동됩니다.')
          this.resetTournamentFilterList()
          return
        }

        this.hasMore = result.hasMore
        this.feedSupplier = result.feedSupplier
        this.marketProviderData = result.marketProviderData

        if (result.lastOrderId) {
          this.lastOrderId = _.toString(result.lastOrderId)
        }

        const trackList = _.concat([], this.filteredTracks)
        _.forEach(result.tracks, track => {
          this.updateIsTournamentFavoriteInTournamentTrack(track)
          trackList.push(track)
        })

        this.filteredTracks = trackList
        this.matchupBlockLeagueFilterBannerVisibleIndex = this.filteredTracks.length // 리그 필터는 매치리스트 하단에 배너 위치
        this.setIsBannerRendered(false)
        this.makeTournamentTrackMatchInfos(pageType) // 띠배너 위치를 계산하기 위한 맵생성
      })
    } catch (err) {
      runInAction(() => {
        this.hasMore = false
        this.isLoading = false
        this.filteredTracks = []
        this.lastOrderId = undefined
      })
      console.error(err)
      // 리그필터에서 에러났을 시 문구?
    }

    return null
  }

  @action
  resetMatchTabSelection = () => {
    this.setCategoryTab(0, GAME_TYPE.CROSS, false)
    this.setSportTab(0, SPORTS_TYPE.HOT, Number(SPORTS_TYPE.HOT))
    this.setMajorUniqueID(EXCEPTIONAL_UNIQUE_ID.TOTAL_LEAGUE)
  }

  @action
  setMatchupFilters(matchupFilters: Schema$MatchupFilter[]): void {
    this.matchupFilterList = matchupFilters
  }

  @action
  updateMatchUserPickWritten(matchId: number): void {
    if (!_.isEmpty(this.tracks)) {
      for (const track of this.tracks) {
        const existsMatch = _.find(track.matches, { matchId })
        if (existsMatch) {
          existsMatch.userPickCount = _.toNumber(existsMatch.userPickCount) + 1
          break
        }
      }
    }
  }

  @action
  updateMatchCheerForTeamWritten(matchId: number): void {
    if (!_.isEmpty(this.tracks)) {
      for (const track of this.tracks) {
        const existsMatch = _.find(track.matches, { matchId })
        if (existsMatch) {
          existsMatch.cheerForTeamCount = _.toNumber(existsMatch.cheerForTeamCount) + 1
          break
        }
      }
    }

    if (!_.isEmpty(this.filteredTracks)) {
      for (const track of this.filteredTracks) {
        const existsMatch = _.find(track.matches, { matchId })
        if (existsMatch) {
          existsMatch.cheerForTeamCount = _.toNumber(existsMatch.cheerForTeamCount) + 1
          break
        }
      }
    }
  }

  @action
  updateMatchCheerForTeamDeleted(matchId: number): void {
    if (!_.isEmpty(this.tracks)) {
      for (const track of this.tracks) {
        const existsMatch = _.find(track.matches, { matchId })
        if (existsMatch) {
          existsMatch.cheerForTeamCount = _.toNumber(existsMatch.cheerForTeamCount) - 1
          break
        }
      }
    }

    if (!_.isEmpty(this.filteredTracks)) {
      for (const track of this.filteredTracks) {
        const existsMatch = _.find(track.matches, { matchId })
        if (existsMatch) {
          existsMatch.cheerForTeamCount = _.toNumber(existsMatch.cheerForTeamCount) - 1
          break
        }
      }
    }
  }

  @action
  setClubNoticeReadHistories = (clubNoticeIds: string[]) => {
    this.clubNoticeHistories = _.concat([], clubNoticeIds)
  }

  @action
  addClubNoticeReadHistory = (clubNoticeIds: string[]) => {
    this.clubNoticeHistories = _.union([...clubNoticeIds], this.clubNoticeHistories)
  }

  @action
  getSimpleMatchTimelineGroup = (matchId: number, withTimelineEvent: boolean): Promise<SimpleMatchTimelineGroup> => {
    try {
      return this.api.v2.getSimpleMatchTimelineGroup(matchId, withTimelineEvent)
    } catch (err) {
      console.error(err)
    }
  }

  @action
  setIsKeepMatchDetail = (value: boolean) => {
    this.isKeepMatchDetail = value
  }

  @action
  setMatchupDetailContentTabKey = (key: MATCHUP_DETAIL_CONTENT_TAB_KEY) => {
    this.matchupDetailContentTabKey = key
  }

  @action
  setSportTalkUserBlock = (matchIds: number[], userPromiseId: string, isBlocked: boolean) => {
    _.forEach(this.tracks, track => {
      _.forEach(track.matches, matchTrack => {
        const { matchId, sportTalkPreview } = matchTrack

        if (!sportTalkPreview
          || !_.includes(matchIds, matchId)) {
          return
        }

        const { sportTalk } = sportTalkPreview

        if (!sportTalk) {
          return
        }

        if (sportTalk.owner.userPromiseId === userPromiseId) {
          sportTalk.isBlocked = isBlocked
        }
      })
    })
  }

  documentVisibleChangeHandler = (isHidden: boolean) => {
    if (!isMobile) {
      return
    }

    if (isHidden) {
      return
    }

    if (this.currentGameKey === GAME_TYPE.LIVE) {
      this.fetchTournamentTracks({
        limit: 999,
        reset: true,
        pageType: PAGE_TYPE.LIVE,
      }).catch(console.error)
    }
  }

  makeTournamentTrackMatchInfos = (pageType: PAGE_TYPE): void => {
    if (this.currentGameKey === GAME_TYPE.LIVE) {
      return
    }
    const globalBannerOrder = globalStore.getMatchListBannerOrder()
    const leagueFilter = pageType === PAGE_TYPE.MATCHUP_FILTER || pageType === PAGE_TYPE.MATCHUP_RESULT_FILTER
    const isFavoriteMatch = this.majorUniqueID === EXCEPTIONAL_UNIQUE_ID.FAVORITE_MATCH
    const isMyBetMatch = this.majorUniqueID === EXCEPTIONAL_UNIQUE_ID.MY_BET_MATCH

    // 배너를 이미 표시했거나 최하단 매치 아래 배너를 표시하는 경우
    if ((this.isBannerRendered || globalBannerOrder === 0) && !leagueFilter && !isFavoriteMatch && !isMyBetMatch) {
      return
    }

    const tracks: TournamentTrack[] = leagueFilter ? this.filteredTracks : this.tracks

    const flatData = _.flatMap(tracks, (track, index) =>
      _.map(track.matches, (match) => ({
        tournamentId: track.tournamentId,
        tournamentIndex: index,
        matchId: match.matchId,
      })),
    )
    if (!leagueFilter && !isFavoriteMatch && !isMyBetMatch &&  flatData.length >= globalBannerOrder) {
      this.setIsBannerRendered(true)
    }

    if (!leagueFilter) {
      this.flatTournamentTrackMatchInfos = flatData
    } else {
      this.flatLeagueFilterTournamentTrackMatchInfos = flatData
    }
  }

  setIsBannerRendered = (value: boolean): void => {
    this.isBannerRendered = value
  }

  setSelectedDetailTabs(next: DETAIL_TAB[]): void
  setSelectedDetailTabs(updater: TabsUpdater<DETAIL_TAB>): void

  @action
  setSelectedDetailTabs(nextOrUpdater: DETAIL_TAB[] | TabsUpdater<DETAIL_TAB>): void {
    const prev = this.selectedDetailTabs
    const next =
      typeof nextOrUpdater === "function"
        ? nextOrUpdater(prev)
        : nextOrUpdater

    this.selectedDetailTabs = next
  }

  setFilteredSelectedDetailTabs(next: DETAIL_TAB[]): void
  setFilteredSelectedDetailTabs(updater: TabsUpdater<DETAIL_TAB>): void

  @action
  setFilteredSelectedDetailTabs(nextOrUpdater: DETAIL_TAB[] | TabsUpdater<DETAIL_TAB>): void {
    const prev = this.filteredSelectedDetailTabs
    const next = typeof nextOrUpdater === 'function' ? nextOrUpdater(prev) : nextOrUpdater
    this.filteredSelectedDetailTabs = next
  }

  @action
  setBetSlipScrollToTop = (value: boolean) => {
    this.isBetSlipScrollToTop = value
  }

  @action
  setFilterEventOnly = (filterEventOnly: boolean) => {
    this.filterEventOnly = filterEventOnly
  }
}

export default new MatchupStore()

